// src/templates/templateData.js

const templateData = {
  // ==================== SCRAPING TEMPLATES ====================
  jobs_linkedin: {
    meta: {
      name: { en: "LinkedIn jobs", pl: "Oferty pracy LinkedIn" },
      desc: { en: "Scrape LinkedIn job listings by keywords", pl: "Scrapuj oferty z LinkedIn według słów kluczowych" },
      badge: "scraping",
    },
    prefill: {
      taskType: "scraping",
      taskName: { en: "LinkedIn jobs", pl: "Oferty pracy LinkedIn" },
      scraping: {
        selectedSocial: "linkedin",
        selectedPlatform: "linkedin_posts",
        whoToFind: "Software engineer job postings",
        keywords: '"software engineer" job posting\n"frontend developer" hiring\n"fullstack developer" open position',
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["any"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
    },
  },

  jobs_indeed: {
    meta: {
      name: { en: "Indeed jobs", pl: "Oferty pracy Indeed" },
      desc: { en: "Scrape Indeed job listings", pl: "Scrapuj oferty z Indeed" },
      badge: "scraping",
    },
    prefill: {
      taskType: "scraping",
      taskName: { en: "Indeed jobs", pl: "Oferty pracy Indeed" },
      scraping: {
        selectedSocial: "",
        selectedPlatform: "",
        whoToFind: "",
        keywords: "",
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["any"], maxPages: 5 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
    },
  },

  // ==================== FILTERING TEMPLATES ====================
  lead_filter: {
    meta: {
      name: { en: "Lead filter", pl: "Filtr leadów" },
      desc: { en: "AI filters contacts by industry and role", pl: "AI filtruje kontakty według branży i stanowiska" },
      badge: "filtering",
    },
    prefill: {
      taskType: "filtering",
      taskName: { en: "Lead filter", pl: "Filtr leadów" },
      filtering: {
        rules: [{ id: "rule-1", field: "job_title", operator: "contains", value: "manager" }],
        matchType: "all",
        useAI: true,
        aiGoal: "Filter leads that are decision makers in tech companies",
        aiPrompt: `Analyze the content and respond with "yes" or "no" on the FIRST LINE.\nExplain your reasoning on the second line.\n\nData points:\n- Job Title: [[job_title]]\n- Company: [[company]]\n- Bio: [[bio]]\n\nPasses filter if response contains "yes"`,
        matchWord: "yes",
        matchScope: "first_line",
      },
    },
  },

  news_digest: {
    meta: {
      name: { en: "News digest", pl: "Przegląd wiadomości" },
      desc: { en: "Filter news by relevance using a prompt", pl: "Filtruj wiadomości według trafności promptem" },
      badge: "filtering",
    },
    prefill: {
      taskType: "filtering",
      taskName: { en: "News digest", pl: "Przegląd wiadomości" },
      filtering: {
        rules: [],
        matchType: "all",
        useAI: true,
        aiGoal: "Keep only news about AI and machine learning breakthroughs",
        aiPrompt: "",
        matchWord: "yes",
        matchScope: "full_text",
      },
    },
  },

  // ==================== SCRAPING + FILTERING TEMPLATES ====================
  b2b_outreach: {
    meta: {
      name: { en: "B2B outreach", pl: "B2B outreach" },
      desc: { en: "Scrape companies and auto-qualify them", pl: "Scrapuj firmy i automatycznie je kwalifikuj" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "B2B outreach", pl: "B2B outreach" },
      scraping: {
        selectedSocial: "linkedin",
        selectedPlatform: "linkedin_posts",
        whoToFind: "Marketing managers at SaaS companies in London",
        keywords: '"marketing manager" "SaaS" London\n"head of marketing" startup London\n"growth manager" B2B London',
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["any"], maxPages: 5 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [
          { id: "rule-1", field: "job_title", operator: "contains", value: "marketing" },
          { id: "rule-2", field: "company_size", operator: "greater_than", value: "10" },
        ],
        matchType: "all",
        useAI: true,
        aiGoal: "Qualify leads: must be decision makers in growing tech companies",
        aiPrompt: `Analyze the content and respond with "yes" or "no" on the FIRST LINE.\nExplain your reasoning on the second line.\n\nData points:\n- Job Title: [[job_title]]\n- Company: [[company]]\n- Bio: [[bio]]\n- Post Content: [[post_content]]\n\nIMPORTANT: Result passes ONLY if response FIRST LINE contains "yes"`,
        matchWord: "yes",
        matchScope: "first_line",
      },
    },
  },

  event_monitoring: {
    meta: {
      name: { en: "Event monitoring", pl: "Monitoring wydarzeń" },
      desc: { en: "Parse event sites and keep only matches", pl: "Parsuj strony wydarzeń i zachowuj tylko pasujące" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Event monitoring", pl: "Monitoring wydarzeń" },
      scraping: {
        selectedSocial: "",
        selectedPlatform: "",
        whoToFind: "",
        keywords: "",
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["any"], maxPages: 5 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "all",
        useAI: true,
        aiGoal: "",
        aiPrompt: "",
        matchWord: "yes",
        matchScope: "full_text",
      },
    },
  },

  // ==================== INSTAGRAM REELS ====================
  instagram_reels_general_template: {
    meta: {
      name: { en: "Instagram Reels Analyzer" },
      desc: { en: "Find best Instagram Reels" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Instagram Reels Analyzer" },
      scraping: {
        aiPrompt: "Write 6 relevant keywords or search phrases for finding Instagram Reels corresponding to {target}. Write only resulted rows on new lines. Do not use numbers, bullet points, or markdown.",
        selectedSocial: "instagram",
        selectedPlatform: "instagram_reels",
        whoToFind: "[your niche]",
        keywords: '',
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 10 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "all",
        useAI: true,
        aiGoal: "Filter reels from business accounts with high engagement potential",
        aiPrompt: "",
        aiMiddlePart: "Check the user's profile screenshot [[USER_SCREENSHOT]]. Is this a page of [your_niche]?",
        matchWord: "yes",
        matchScope: "first_line",
        reelsMetrics: {
          enabled: true,
          minViews: "1000",
          maxViews: "",
          minLikes: "",
          maxLikes: "",
          minComments: "",
          maxComments: "",
          minEngagementRate: "",
          maxEngagementRate: "",
          engagementFormula: "standard",
          topReelsCount: 30,
          sortBy: "engagement",
          needFilter: false,
          needDescription: true,
          generateSummary: true,
          summaryPrompt: "Analyze these top-performing Reels and create a comprehensive summary.\n\nFor each reel, consider:\n- Content description\n- Engagement metrics (views, likes, comments)\n- Engagement rate\n- Key patterns and trends\n\nProvide:\n1. Overall trends across all reels\n2. Common characteristics of top performers\n3. Recommendations for content strategy",
          _summaryPromptInitialized: true,
          filterMethods: ["user_profile"],
        },
        _aiPromptInitialized: false,
      },
    },
  },

  instagram_reels_general_template_pl: {
    meta: {
      name: { pl: "Analizator Rolek Instagram" },
      desc: { pl: "Znajdź najlepsze Rolki Instagram" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { pl: "Analizator Rolek Instagram" },
      scraping: {
        aiPrompt: "Napisz 6 odpowiednich słów kluczowych lub fraz wyszukiwania do znalezienia Rolek Instagram odpowiadających {target}. Napisz tylko wynikowe wiersze w nowych liniach. Nie używaj liczb, wypunktowań ani markdown.",
        selectedSocial: "instagram",
        selectedPlatform: "instagram_reels",
        whoToFind: "[twoja nisza]",
        keywords: '',
        advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 10 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "all",
        useAI: true,
        aiGoal: "Filtruj rolki z kont biznesowych o wysokim potencjale zaangażowania",
        aiPrompt: "",
        aiMiddlePart: "Rolka musi dotyczyć [twoja nisza]",
        matchWord: "tak",
        matchScope: "first_line",
        reelsMetrics: {
          enabled: true,
          minViews: "1000",
          maxViews: "",
          minLikes: "",
          maxLikes: "",
          minComments: "",
          maxComments: "",
          minEngagementRate: "",
          maxEngagementRate: "",
          engagementFormula: "standard",
          topReelsCount: 30,
          sortBy: "engagement",
          needFilter: false,
          needDescription: true,
          generateSummary: true,
          summaryPrompt: "Przeanalizuj te najlepiej wypadające Rolki i stwórz kompleksowe podsumowanie.\n\nDla każdej rolki weź pod uwagę:\n- Opis treści\n- Wskaźniki zaangażowania (wyświetlenia, polubienia, komentarze)\n- Wskaźnik zaangażowania\n- Kluczowe wzorce i trendy\n\nPodaj:\n1. Ogólne trendy we wszystkich rolkach\n2. Wspólne cechy najlepiej wypadających rolek\n3. Rekomendacje dla strategii treści",
          _summaryPromptInitialized: true,
          filterMethods: ["user_profile"],
        },
        _aiPromptInitialized: false,
      },
    },
  },

  instagram_reels_smm_analysis: {
    meta: {
      name: { en: "Instagram Reels For SMM creators" },
      desc: { en: "Find best Instagram Reels" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Instagram Reels For SMM creators" },
      scraping: {
        selectedSocial: "instagram",
        selectedPlatform: "instagram_reels",
        whoToFind: "Creators with viral reels in SMM niche",
        keywords: 'smm\nsocial media tips\nugc creator\nsmma',
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 10 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "all",
        useAI: true,
        aiGoal: "Filter reels from SMM bloggers",
        aiPrompt: "",
        aiMiddlePart: "Check the user's profile screenshot [[USER_SCREENSHOT]]. Is this a page of an SMM (Social Media Marketing) blogger? The profile should belong to someone who creates content about social media marketing, growth strategies, content creation tips, or social media management.\n\nRespond 'yes' if it's an SMM blogger profile, 'no' if it's not.",
        matchWord: "yes",
        matchScope: "first_line",
        reelsMetrics: {
          enabled: true,
          minViews: "1000",
          maxViews: "",
          minLikes: "",
          maxLikes: "",
          minComments: "",
          maxComments: "",
          minEngagementRate: "",
          maxEngagementRate: "",
          engagementFormula: "standard",
          topReelsCount: 45,
          sortBy: "engagement",
          needFilter: true,
          needDescription: true,
          generateSummary: true,
          summaryPrompt: "Analyze these top-performing Reels and create a comprehensive summary.\n\nFor each reel, consider:\n- Content description\n- Engagement metrics (views, likes, comments)\n- Engagement rate\n- Key patterns and trends\n\nProvide:\n1. Overall trends across all reels\n2. Common characteristics of top performers\n3. Recommendations for content strategy",
          _summaryPromptInitialized: true,
          filterMethods: ["user_profile"],
        },
        _aiPromptInitialized: false,
      },
    },
  },

  instagram_reels_smm_analysis_pl: {
    meta: {
      name: { pl: "Instagram Reels dla twórców SMM" },
      desc: { pl: "Znajdź najlepsze rolki na Instagramie" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { pl: "Instagram Reels dla twórców SMM" },
      scraping: {
        selectedSocial: "instagram",
        selectedPlatform: "instagram_reels",
        whoToFind: "Twórcy z wiralowymi rolkami w niszy SMM",
        keywords: 'smm\nsocial media tips\nugc creator\nsmma',
        advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 10 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "all",
        useAI: true,
        aiGoal: "Przefiltruj rolki z kont biznesowych o wysokim potencjale zaangażowania",
        aiPrompt: "",
        aiMiddlePart: "Rolka musi dotyczyć tematyki SMM",
        matchWord: "tak",
        matchScope: "first_line",
        reelsMetrics: {
          enabled: true,
          minViews: "1000",
          maxViews: "",
          minLikes: "",
          maxLikes: "",
          minComments: "",
          maxComments: "",
          minEngagementRate: "",
          maxEngagementRate: "",
          engagementFormula: "standard",
          topReelsCount: 30,
          sortBy: "engagement",
          needFilter: false,
          needDescription: true,
          generateSummary: true,
          summaryPrompt: "Przeanalizuj te najlepiej radzące sobie rolki (Reels) i stwórz kompleksowe podsumowanie.\n\nDla każdej rolki weź pod uwagę:\n- Opis treści\n- Wskaźniki zaangażowania (wyświetlenia, polubienia, komentarze)\n- Wskaźnik zaangażowania (Engagement Rate)\n- Kluczowe wzorce i trendy\n\nPrzygotuj:\n1. Ogólne trendy widoczne we wszystkich rolkach\n2. Wspólne cechy najpopularniejszych materiałów\n3. Rekomendacje dla strategii treści",
          _summaryPromptInitialized: true,
          filterMethods: ["user_profile"],
        },
        _aiPromptInitialized: false,
      },
    },
  },

  // --- SMM & MARKETING ---
  instagram_reels_smm_creators: {
    meta: {
      name: { en: "SMM Creators & Agencies" },
      desc: { en: "Find SMM creators posting tips, strategies, case studies" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "SMM Creators Reels" },
      scraping: {
        selectedSocial: "instagram",
        selectedPlatform: "instagram_reels",
        whoToFind: "SMM creators posting tips and strategies",
        keywords: 'smm tips\nsocial media strategy\ncontent creator tips\nsocial media manager\ninstagram growth\nsmm agency\nsocial media marketing',
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 10 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "all",
        useAI: true,
        aiGoal: "Filter SMM creators",
        aiPrompt: "",
        aiMiddlePart: "Check [[USER_SCREENSHOT]] and [[USER_BIO]]. Is this an SMM creator, agency, or social media expert? They should post about social media marketing, content strategy, growth hacks, or client results.\n\nRespond 'yes' or 'no'.",
        matchWord: "yes",
        matchScope: "first_line",
        reelsMetrics: {
          enabled: true, minViews: "5000", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
          minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 30,
          sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
          summaryPrompt: "Analyze these top SMM reels. Identify trending topics, common hooks, engagement patterns, and content formats that perform best.",
          _summaryPromptInitialized: true, filterMethods: ["user_profile"],
        },
        _aiPromptInitialized: false,
      },
    },
  },

  instagram_reels_ugc_creators: {
    meta: {
      name: { en: "UGC Creators" },
      desc: { en: "Find User-Generated Content creators for brands" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "UGC Creators Reels" },
      scraping: {
        selectedSocial: "instagram", selectedPlatform: "instagram_reels",
        whoToFind: "UGC creators making authentic content for brands",
        keywords: 'ugc creator\nuser generated content\nugc portfolio\nbrand deal\nugc example\ncontent creator for hire',
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 10 },
        scheduleType: "once", parseAuthorPages: false,
      },
      filtering: {
        rules: [], matchType: "all", useAI: true,
        aiGoal: "Filter UGC creators",
        aiPrompt: "", aiMiddlePart: "Check [[USER_BIO]] and [[USER_SCREENSHOT]]. Is this a UGC creator who makes authentic product videos for brands? Look for portfolio links, 'UGC' in bio, brand collaboration examples.\n\nRespond 'yes' or 'no'.",
        matchWord: "yes", matchScope: "first_line",
        reelsMetrics: {
          enabled: true, minViews: "2000", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
          minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 25,
          sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
          summaryPrompt: "Analyze these UGC reels. What types of products are featured? What shooting styles work best? Identify trends in authentic content creation.",
          _summaryPromptInitialized: true, filterMethods: ["user_profile"],
        },
        _aiPromptInitialized: false,
      },
    },
  },

  // --- E-COMMERCE & RETAIL ---
  instagram_reels_ecommerce_fashion: {
    meta: {
      name: { en: "Fashion & Clothing Brands" },
      desc: { en: "Find fashion brands, boutiques, clothing stores on Reels" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Fashion Brands Reels" },
      scraping: {
        selectedSocial: "instagram", selectedPlatform: "instagram_reels",
        whoToFind: "Fashion brands and clothing stores posting reels",
        keywords: 'new collection\noutfit inspiration\nfashion haul\nstreetwear\nsustainable fashion\nclothing brand\nboutique shopping',
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 15 },
        scheduleType: "once", parseAuthorPages: false,
      },
      filtering: {
        rules: [], matchType: "all", useAI: true,
        aiGoal: "Filter fashion brands",
        aiPrompt: "", aiMiddlePart: "Check [[USER_BIO]], [[USER_SCREENSHOT]], and [[REELS_INFO_TEXT]]. Is this a fashion brand, clothing store, or boutique that sells products? Look for shop links, sizing info, product announcements.\n\nRespond 'yes' or 'no'.",
        matchWord: "yes", matchScope: "first_line",
        reelsMetrics: {
          enabled: true, minViews: "3000", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
          minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 30,
          sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
          summaryPrompt: "Analyze these fashion reels. What styles are trending? Which formats get most engagement (hauls, outfit transitions, behind the scenes)?",
          _summaryPromptInitialized: true, filterMethods: ["user_profile", "reel_info"],
        },
        _aiPromptInitialized: false,
      },
    },
  },

  instagram_reels_beauty_cosmetics: {
    meta: {
      name: { en: "Beauty & Cosmetics" },
      desc: { en: "Find beauty brands, skincare, makeup on Reels" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Beauty Brands Reels" },
      scraping: {
        selectedSocial: "instagram", selectedPlatform: "instagram_reels",
        whoToFind: "Beauty and cosmetics brands posting reels",
        keywords: 'skincare routine\nmakeup tutorial\nbeauty products\ncosmetics review\nkbeauty\nclean beauty\nserum review',
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 12 },
        scheduleType: "once", parseAuthorPages: false,
      },
      filtering: {
        rules: [], matchType: "all", useAI: true,
        aiGoal: "Filter beauty brands",
        aiPrompt: "", aiMiddlePart: "Check [[USER_BIO]], [[USER_FULLNAME]], and [[REELS_INFO_TEXT]]. Is this a beauty brand, skincare line, or cosmetics company? Look for product mentions, ingredients, before/after content.\n\nRespond 'yes' or 'no'.",
        matchWord: "yes", matchScope: "first_line",
        reelsMetrics: {
          enabled: true, minViews: "5000", maxViews: "", minLikes: "100", maxLikes: "", minComments: "", maxComments: "",
          minEngagementRate: "2", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 30,
          sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
          summaryPrompt: "Analyze these beauty reels. What product categories dominate? What video styles perform best? Identify key engagement drivers.",
          _summaryPromptInitialized: true, filterMethods: ["user_profile", "reel_info"],
        },
        _aiPromptInitialized: false,
      },
    },
  },

  instagram_reels_home_decor: {
    meta: {
      name: { en: "Home Decor & Furniture" },
      desc: { en: "Find interior design, home decor brands on Reels" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Home Decor Reels" },
      scraping: {
        selectedSocial: "instagram", selectedPlatform: "instagram_reels",
        whoToFind: "Home decor brands and interior design accounts",
        keywords: 'home decor\ninterior design\nroom makeover\nfurniture shop\ndecor haul\nhometour\napartment decor',
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["m"], maxPages: 10 },
        scheduleType: "once", parseAuthorPages: false,
      },
      filtering: {
        rules: [], matchType: "all", useAI: true,
        aiGoal: "Filter home decor businesses",
        aiPrompt: "", aiMiddlePart: "Check [[USER_BIO]] and [[USER_SCREENSHOT]]. Is this a home decor brand, furniture store, or interior designer selling products/services? Look for shop links, project portfolios, product catalogs.\n\nRespond 'yes' or 'no'.",
        matchWord: "yes", matchScope: "first_line",
        reelsMetrics: {
          enabled: true, minViews: "3000", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
          minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 25,
          sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
          summaryPrompt: "Analyze these home decor reels. What styles are trending? Which room types get most views? Identify popular decor formats.",
          _summaryPromptInitialized: true, filterMethods: ["user_profile"],
        },
        _aiPromptInitialized: false,
      },
    },
  },

  // --- FOOD & BEVERAGE ---
  instagram_reels_food_restaurants: {
    meta: {
      name: { en: "Restaurants & Food Businesses" },
      desc: { en: "Find restaurants, cafes, food brands on Reels" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Food Business Reels" },
      scraping: {
        selectedSocial: "instagram", selectedPlatform: "instagram_reels",
        whoToFind: "Restaurants, cafes, and food businesses",
        keywords: 'restaurant\ncafe food\nfoodie\nstreet food\nbakery\ndessert shop\nbrunch spot\nfood business',
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 12 },
        scheduleType: "once", parseAuthorPages: false,
      },
      filtering: {
        rules: [], matchType: "all", useAI: true,
        aiGoal: "Filter food businesses",
        aiPrompt: "", aiMiddlePart: "Check [[USER_BIO]], [[USER_FULLNAME]], and [[REELS_INFO_TEXT]]. Is this a restaurant, cafe, bakery, or food brand? Look for menu mentions, location tags, order links, food photos.\n\nRespond 'yes' or 'no'.",
        matchWord: "yes", matchScope: "first_line",
        reelsMetrics: {
          enabled: true, minViews: "2000", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
          minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 30,
          sortBy: "views", needFilter: true, needDescription: true, generateSummary: true,
          summaryPrompt: "Analyze these food reels. What cuisines dominate? Which video formats get most engagement? Identify trends in food content.",
          _summaryPromptInitialized: true, filterMethods: ["user_profile", "reel_info"],
        },
        _aiPromptInitialized: false,
      },
    },
  },

  instagram_reels_food_creators: {
    meta: {
      name: { en: "Food Bloggers & Recipe Creators" },
      desc: { en: "Find food content creators, recipe developers" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Food Creators Reels" },
      scraping: {
        selectedSocial: "instagram", selectedPlatform: "instagram_reels",
        whoToFind: "Food bloggers and recipe creators",
        keywords: 'recipe\ncooking tutorial\nfood blog\nhome cooking\neasy recipe\nmeal prep\nfood review',
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 10 },
        scheduleType: "once", parseAuthorPages: false,
      },
      filtering: {
        rules: [], matchType: "all", useAI: true,
        aiGoal: "Filter food creators",
        aiPrompt: "", aiMiddlePart: "Check [[USER_BIO]] and [[USER_SCREENSHOT]]. Is this a food content creator, recipe developer, or food blogger? They create cooking content, not just a restaurant page.\n\nRespond 'yes' or 'no'.",
        matchWord: "yes", matchScope: "first_line",
        reelsMetrics: {
          enabled: true, minViews: "3000", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
          minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 30,
          sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
          summaryPrompt: "Analyze these food creator reels. What recipe types trend? Which cooking styles get most saves? Identify content patterns.",
          _summaryPromptInitialized: true, filterMethods: ["user_profile"],
        },
        _aiPromptInitialized: false,
      },
    },
  },

  // --- FITNESS & WELLNESS ---
  instagram_reels_fitness_coaches: {
    meta: {
      name: { en: "Fitness Coaches & Trainers" },
      desc: { en: "Find personal trainers, fitness coaches on Reels" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Fitness Coaches Reels" },
      scraping: {
        selectedSocial: "instagram", selectedPlatform: "instagram_reels",
        whoToFind: "Fitness coaches and personal trainers",
        keywords: 'workout routine\nfitness coach\npersonal trainer\ngym tips\nexercise tutorial\nweight loss\ntransformation',
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 12 },
        scheduleType: "once", parseAuthorPages: false,
      },
      filtering: {
        rules: [], matchType: "all", useAI: true,
        aiGoal: "Filter fitness professionals",
        aiPrompt: "", aiMiddlePart: "Check [[USER_BIO]] and [[USER_SCREENSHOT]]. Is this a fitness coach, personal trainer, or workout instructor? Look for certifications, training programs, client results.\n\nRespond 'yes' or 'no'.",
        matchWord: "yes", matchScope: "first_line",
        reelsMetrics: {
          enabled: true, minViews: "2000", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
          minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 30,
          sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
          summaryPrompt: "Analyze these fitness reels. What workout types dominate? Which formats get most saves? Identify engagement patterns.",
          _summaryPromptInitialized: true, filterMethods: ["user_profile"],
        },
        _aiPromptInitialized: false,
      },
    },
  },

  instagram_reels_wellness_mindfulness: {
    meta: {
      name: { en: "Wellness & Mindfulness" },
      desc: { en: "Find yoga, meditation, wellness coaches on Reels" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Wellness Reels" },
      scraping: {
        selectedSocial: "instagram", selectedPlatform: "instagram_reels",
        whoToFind: "Wellness coaches, yoga instructors, mindfulness creators",
        keywords: 'yoga practice\nmeditation tips\nwellness coach\nmindfulness\nself care routine\nmental health tips\nholistic health',
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 10 },
        scheduleType: "once", parseAuthorPages: false,
      },
      filtering: {
        rules: [], matchType: "all", useAI: true,
        aiGoal: "Filter wellness creators",
        aiPrompt: "", aiMiddlePart: "Check [[USER_BIO]] and [[REELS_INFO_TEXT]]. Is this a wellness coach, yoga teacher, or mindfulness practitioner? Look for certifications, class offerings, retreat info.\n\nRespond 'yes' or 'no'.",
        matchWord: "yes", matchScope: "first_line",
        reelsMetrics: {
          enabled: true, minViews: "1500", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
          minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 25,
          sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
          summaryPrompt: "Analyze these wellness reels. What practices are trending? Which formats resonate most? Identify content patterns.",
          _summaryPromptInitialized: true, filterMethods: ["user_profile", "reel_info"],
        },
        _aiPromptInitialized: false,
      },
    },
  },

  // --- EDUCATION & COACHING ---
  instagram_reels_business_coaches: {
    meta: {
      name: { en: "Business Coaches & Consultants" },
      desc: { en: "Find business coaches, consultants, mentors on Reels" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Business Coaches Reels" },
      scraping: {
        selectedSocial: "instagram", selectedPlatform: "instagram_reels",
        whoToFind: "Business coaches and consultants",
        keywords: 'business coach\nentrepreneur tips\nbusiness strategy\nstartup advice\nconsulting\nscaling business\nmarketing consultant',
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 12 },
        scheduleType: "once", parseAuthorPages: false,
      },
      filtering: {
        rules: [], matchType: "all", useAI: true,
        aiGoal: "Filter business coaches",
        aiPrompt: "", aiMiddlePart: "Check [[USER_BIO]], [[USER_FULLNAME]], and [[USER_SCREENSHOT]]. Is this a business coach, consultant, or mentor who sells services/programs? Look for 'coach', 'consultant', booking links, client results.\n\nRespond 'yes' or 'no'.",
        matchWord: "yes", matchScope: "first_line",
        reelsMetrics: {
          enabled: true, minViews: "3000", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
          minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 30,
          sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
          summaryPrompt: "Analyze these business coaching reels. What topics trend? Which hooks work best? Identify high-performing content patterns.",
          _summaryPromptInitialized: true, filterMethods: ["user_profile", "reel_info"],
        },
        _aiPromptInitialized: false,
      },
    },
  },

  instagram_reels_online_teachers: {
    meta: {
      name: { en: "Online Teachers & Course Creators" },
      desc: { en: "Find educators, tutors, course creators on Reels" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Educators Reels" },
      scraping: {
        selectedSocial: "instagram", selectedPlatform: "instagram_reels",
        whoToFind: "Online teachers, tutors, and course creators",
        keywords: 'online course\nlearn online\ntutoring\neducation tips\nstudy hacks\nlanguage teacher\nskillshare',
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 10 },
        scheduleType: "once", parseAuthorPages: false,
      },
      filtering: {
        rules: [], matchType: "all", useAI: true,
        aiGoal: "Filter educators",
        aiPrompt: "", aiMiddlePart: "Check [[USER_BIO]] and [[REELS_INFO_TEXT]]. Is this an online teacher, tutor, or course creator? Look for course links, teaching credentials, educational content.\n\nRespond 'yes' or 'no'.",
        matchWord: "yes", matchScope: "first_line",
        reelsMetrics: {
          enabled: true, minViews: "1500", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
          minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 25,
          sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
          summaryPrompt: "Analyze these educational reels. What subjects dominate? Which teaching formats work best? Identify engagement patterns.",
          _summaryPromptInitialized: true, filterMethods: ["user_profile", "reel_info"],
        },
        _aiPromptInitialized: false,
      },
    },
  },

  // --- REAL ESTATE ---
  instagram_reels_real_estate: {
    meta: {
      name: { en: "Real Estate Agents & Agencies" },
      desc: { en: "Find realtors, property agents on Reels" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Real Estate Reels" },
      scraping: {
        selectedSocial: "instagram", selectedPlatform: "instagram_reels",
        whoToFind: "Real estate agents and property agencies",
        keywords: 'real estate agent\nproperty tour\nhouse for sale\nrealtor life\nluxury home\napartment tour\nreal estate tips',
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 12 },
        scheduleType: "once", parseAuthorPages: false,
      },
      filtering: {
        rules: [], matchType: "all", useAI: true,
        aiGoal: "Filter real estate professionals",
        aiPrompt: "", aiMiddlePart: "Check [[USER_BIO]], [[USER_FULLNAME]], and [[REELS_INFO_TEXT]]. Is this a real estate agent, broker, or property agency? Look for license info, property listings, 'realtor', contact details.\n\nRespond 'yes' or 'no'.",
        matchWord: "yes", matchScope: "first_line",
        reelsMetrics: {
          enabled: true, minViews: "1500", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
          minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 30,
          sortBy: "views", needFilter: true, needDescription: true, generateSummary: true,
          summaryPrompt: "Analyze these real estate reels. What property types dominate? Which video formats get most inquiries? Identify trends.",
          _summaryPromptInitialized: true, filterMethods: ["user_profile", "reel_info"],
        },
        _aiPromptInitialized: false,
      },
    },
  },

  // --- TRAVEL & HOSPITALITY ---
  instagram_reels_travel_creators: {
    meta: {
      name: { en: "Travel Creators & Bloggers" },
      desc: { en: "Find travel influencers, bloggers on Reels" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Travel Creators Reels" },
      scraping: {
        selectedSocial: "instagram", selectedPlatform: "instagram_reels",
        whoToFind: "Travel content creators and bloggers",
        keywords: 'travel vlog\ntravel tips\ndestination guide\nbackpacking\nluxury travel\nsolotravel\ntravel blogger',
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["m"], maxPages: 12 },
        scheduleType: "once", parseAuthorPages: false,
      },
      filtering: {
        rules: [], matchType: "all", useAI: true,
        aiGoal: "Filter travel creators",
        aiPrompt: "", aiMiddlePart: "Check [[USER_BIO]] and [[USER_SCREENSHOT]]. Is this a travel content creator, blogger, or influencer? Look for travel-related bio, blog links, destination content.\n\nRespond 'yes' or 'no'.",
        matchWord: "yes", matchScope: "first_line",
        reelsMetrics: {
          enabled: true, minViews: "5000", maxViews: "", minLikes: "200", maxLikes: "", minComments: "", maxComments: "",
          minEngagementRate: "3", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 30,
          sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
          summaryPrompt: "Analyze these travel reels. What destinations trend? Which formats get most saves? Identify viral patterns.",
          _summaryPromptInitialized: true, filterMethods: ["user_profile"],
        },
        _aiPromptInitialized: false,
      },
    },
  },

  instagram_reels_hotels_resorts: {
    meta: {
      name: { en: "Hotels & Resorts" },
      desc: { en: "Find hotels, resorts, accommodations on Reels" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Hotels Reels" },
      scraping: {
        selectedSocial: "instagram", selectedPlatform: "instagram_reels",
        whoToFind: "Hotels, resorts, and accommodations",
        keywords: 'hotel review\nresort life\nboutique hotel\nluxury resort\nvacation rental\nairbnb tour\nhotel room tour',
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["m"], maxPages: 10 },
        scheduleType: "once", parseAuthorPages: false,
      },
      filtering: {
        rules: [], matchType: "all", useAI: true,
        aiGoal: "Filter hotels/resorts",
        aiPrompt: "", aiMiddlePart: "Check [[USER_BIO]], [[REELS_INFO_TEXT]], and [[USER_SCREENSHOT]]. Is this a hotel, resort, or accommodation business? Look for booking links, location, property features.\n\nRespond 'yes' or 'no'.",
        matchWord: "yes", matchScope: "first_line",
        reelsMetrics: {
          enabled: true, minViews: "3000", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
          minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 25,
          sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
          summaryPrompt: "Analyze these hotel reels. What property types trend? Which features get highlighted? Identify content patterns.",
          _summaryPromptInitialized: true, filterMethods: ["user_profile", "reel_info"],
        },
        _aiPromptInitialized: false,
      },
    },
  },

  // --- TECH & SAAS ---
  instagram_reels_saas_founders: {
    meta: {
      name: { en: "SaaS Founders & Startups" },
      desc: { en: "Find SaaS companies, startup founders on Reels" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "SaaS Founders Reels" },
      scraping: {
        selectedSocial: "instagram", selectedPlatform: "instagram_reels",
        whoToFind: "SaaS founders and tech startups",
        keywords: 'saas founder\nstartup life\ntech entrepreneur\nsoftware company\nproduct launch\nbootstrapping\nindie hacker',
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["m"], maxPages: 10 },
        scheduleType: "once", parseAuthorPages: false,
      },
      filtering: {
        rules: [], matchType: "all", useAI: true,
        aiGoal: "Filter SaaS/tech companies",
        aiPrompt: "", aiMiddlePart: "Check [[USER_BIO]], [[USER_FULLNAME]], and [[REELS_INFO_TEXT]]. Is this a SaaS founder, tech startup, or software company? Look for product links, 'SaaS', 'startup', tech stack mentions.\n\nRespond 'yes' or 'no'.",
        matchWord: "yes", matchScope: "first_line",
        reelsMetrics: {
          enabled: true, minViews: "2000", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
          minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 25,
          sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
          summaryPrompt: "Analyze these SaaS reels. What products are featured? Which content types drive engagement? Identify trends.",
          _summaryPromptInitialized: true, filterMethods: ["user_profile", "reel_info"],
        },
        _aiPromptInitialized: false,
      },
    },
  },

  // --- LOCAL BUSINESSES ---
  instagram_reels_local_business: {
    meta: {
      name: { en: "Local Small Businesses" },
      desc: { en: "Find local shops, salons, services on Reels" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Local Business Reels" },
      scraping: {
        selectedSocial: "instagram", selectedPlatform: "instagram_reels",
        whoToFind: "Local small businesses promoting on Instagram",
        keywords: 'small business\ndowntown\nlocal shop\nsmall biz\ntown\nmain street\nlocal business',
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["m"], maxPages: 10 },
        scheduleType: "once", parseAuthorPages: false,
      },
      filtering: {
        rules: [], matchType: "all", useAI: true,
        aiGoal: "Filter local businesses",
        aiPrompt: "", aiMiddlePart: "Check [[USER_BIO]], [[REELS_INFO_TEXT]], and [[USER_SCREENSHOT]]. Is this a local small business (shop, salon, service, cafe)? Look for address, hours, services, local hashtags.\n\nRespond 'yes' or 'no'.",
        matchWord: "yes", matchScope: "first_line",
        reelsMetrics: {
          enabled: true, minViews: "500", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
          minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 30,
          sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
          summaryPrompt: "Analyze these local business reels. What business types dominate? Which formats drive foot traffic? Identify local marketing trends.",
          _summaryPromptInitialized: true, filterMethods: ["user_profile", "reel_info"],
        },
        _aiPromptInitialized: false,
      },
    },
  },

  // --- CREATIVE & ART ---
  instagram_reels_artists_designers: {
    meta: {
      name: { en: "Artists & Designers" },
      desc: { en: "Find visual artists, graphic designers on Reels" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Artists Reels" },
      scraping: {
        selectedSocial: "instagram", selectedPlatform: "instagram_reels",
        whoToFind: "Visual artists, illustrators, graphic designers",
        keywords: 'digital art\nillustration\nartist studio\ngraphic design\nart process\ncommission open\nart portfolio',
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["m"], maxPages: 10 },
        scheduleType: "once", parseAuthorPages: false,
      },
      filtering: {
        rules: [], matchType: "all", useAI: true,
        aiGoal: "Filter artists/designers",
        aiPrompt: "", aiMiddlePart: "Check [[USER_BIO]] and [[USER_SCREENSHOT]]. Is this a visual artist, illustrator, or graphic designer? Look for portfolio links, commission info, art style descriptions.\n\nRespond 'yes' or 'no'.",
        matchWord: "yes", matchScope: "first_line",
        reelsMetrics: {
          enabled: true, minViews: "1500", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
          minEngagementRate: "", maxEngagementRate: "", engagementFormula: "simple", topReelsCount: 25,
          sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
          summaryPrompt: "Analyze these artist reels. What art styles trend? Which process videos perform best? Identify engagement patterns.",
          _summaryPromptInitialized: true, filterMethods: ["user_profile"],
        },
        _aiPromptInitialized: false,
      },
    },
  },

  instagram_reels_photographers: {
    meta: {
      name: { en: "Photographers & Videographers" },
      desc: { en: "Find professional photographers on Reels" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Photographers Reels" },
      scraping: {
        selectedSocial: "instagram", selectedPlatform: "instagram_reels",
        whoToFind: "Professional photographers and videographers",
        keywords: 'photography tips\nphotoshoot bts\ncamera setup\nwedding photographer\nfilmmaker\nphoto editing\nphotography business',
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["m"], maxPages: 10 },
        scheduleType: "once", parseAuthorPages: false,
      },
      filtering: {
        rules: [], matchType: "all", useAI: true,
        aiGoal: "Filter photographers",
        aiPrompt: "", aiMiddlePart: "Check [[USER_BIO]] and [[USER_SCREENSHOT]]. Is this a professional photographer or videographer offering services? Look for portfolio, booking info, gear mentions.\n\nRespond 'yes' or 'no'.",
        matchWord: "yes", matchScope: "first_line",
        reelsMetrics: {
          enabled: true, minViews: "2000", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
          minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 25,
          sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
          summaryPrompt: "Analyze these photographer reels. What niches dominate? Which formats showcase work best? Identify portfolio trends.",
          _summaryPromptInitialized: true, filterMethods: ["user_profile"],
        },
        _aiPromptInitialized: false,
      },
    },
  },

  // ==================== FACEBOOK — OUTREACH / LEAD GEN (EN) ====================
  smm_client_acquisition: {
    meta: {
      name: { en: "SMM Client Lead Gen" },
      desc: { en: "Find business owners actively looking to hire or struggling with social media." },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "SMM Lead Generation" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Business owners frustrated with social media or actively seeking help",
        keywords: "looking for social media manager\nneed someone to run my Instagram\nhire social media manager\nrecommend me an SMM specialist\nanyone know a good social media person\nneed help with Facebook page\nlooking for Instagram strategist\nwho can manage my social media\noutsource my social media\nneed a content creator for business\nsocial media manager needed\nhiring digital marketer\nlooking for freelance SMM\nneed Instagram manager\nhelp with my business social media\nwho does social media for small business\nneed TikTok manager for brand\nlooking for LinkedIn content help\nneed someone to grow my Instagram\nhiring social media freelancer\nsocial media help for my business\nneed a marketer for Instagram ads\nlooking for Facebook ads specialist\nwho can fix my social media\nneed SMM for my online store\nlooking for local social media help\nhiring content manager\nneed someone to post for my business\nsocial media person for hire\nlooking to hire Instagram expert",
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 2 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Keep only posts from real business owners expressing hiring intent or genuine social media struggles",
        aiPrompt: "You are analyzing a Facebook post to find potential SMM clients.\n\nLOOK FOR:\n- People actively asking for recommendations or looking to hire social media help\n- Business owners frustrated with their social media results (low reach, engagement drops, burnout)\n- Small business owners who clearly run a business but struggle with marketing themselves\n\nEXCLUDE:\n- Social media managers or agencies promoting their own services\n- Generic motivational posts about marketing\n- People complaining about social media as users, not business owners\n- Job seekers looking for employment as SMM specialists\n- Posts that are clearly ads for other products or services\n\nDATA:\nPost Content: [[TEXT]]\n\nReply with exactly YES on the FIRST LINE if this person is a potential SMM client worth contacting. Reply NO otherwise.\nOn the SECOND LINE and beyond, explain your reasoning for the decision.",
        matchWord: "yes",
        matchScope: "first_line",
      },
    },
  },

  digital_marketing_client_acquisition: {
    meta: {
      name: { en: "Digital Marketing Leads" },
      desc: { en: "Find business owners looking for Meta/Google ads help" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Digital Marketing Lead Gen" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Business owners looking for paid ads help or struggling with ad performance",
        keywords: "need facebook ads expert\nlooking for google ads specialist\nhire media buyer\nneed help with meta ads\nfacebook ads not converting\nrecommend an ads manager\nwho can run my ads\nneed ppc specialist\nlooking for performance marketer\nhelp with ad account banned\nneed someone to fix my ROAS\nads not working anymore\ngoogle ads manager needed\nmeta ads freelancer wanted\nlooking to hire media buyer\nneed ad creative help\ncampaign not profitable\nneed facebook pixel setup\nwho does google ads for small business\nneed conversion tracking help\nlooking for paid social expert\nad spend wasted need help\nneed to scale my ads\nlooking for facebook ads consultant\nhire performance marketing agency",
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Keep only posts from real business owners actively seeking paid ads help or expressing frustration with ad results",
        aiPrompt: "You are analyzing a Facebook post to find potential clients for digital marketing / paid ads services.\n\nLOOK FOR:\n- Business owners asking for recommendations for Facebook/Google ads specialists\n- People frustrated with their ad performance (high costs, no conversions, banned accounts)\n- Entrepreneurs looking to hire media buyers or performance marketers\n- Posts showing clear intent to spend money on ads but lacking expertise\n\nEXCLUDE:\n- Other marketers or agencies promoting their own ad services\n- Generic posts about digital marketing news\n- People looking for jobs as media buyers\n- Posts that are clearly ads for courses or tools\n\nDATA:\nPost Content: [[TEXT]]\n\nReply with exactly YES on the FIRST LINE if this person is a potential digital marketing client. Reply NO otherwise.\nOn the SECOND LINE and beyond, explain your reasoning for the decision.",
        matchWord: "yes",
        matchScope: "first_line",
      },
    },
  },

  seo_client_acquisition: {
    meta: {
      name: { en: "SEO Leads" },
      desc: { en: "Find business owners looking for SEO services" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "SEO Lead Generation" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Business owners seeking SEO help or complaining about low traffic",
        keywords: "need SEO expert\nlooking for SEO specialist\nwebsite traffic dropped\nnot ranking on Google\nhire SEO consultant\nhelp with search rankings\nneed backlinks\norganic traffic disappeared\nGoogle update hit my site\nneed SEO audit\nrecommend an SEO agency\nwho does SEO for small business\nneed to rank higher\nwebsite not getting visitors\nlooking for local SEO help\nneed keyword research\nhelp with Google My Business\nSEO not working for my site\nneed someone to fix my SEO\nlooking for SEO freelancer\nsite lost all traffic after update\nneed on-page SEO help\nhelp with technical SEO\nwho can do SEO for my shop\nlooking for white hat SEO\nneed ecommerce SEO expert",
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Keep only posts from real business owners actively seeking SEO help or expressing pain about low organic traffic",
        aiPrompt: "You are analyzing a Facebook post to find potential SEO clients.\n\nLOOK FOR:\n- Business owners asking for SEO recommendations or looking to hire\n- People frustrated with low website traffic or Google ranking drops\n- Entrepreneurs who clearly understand they have an SEO problem\n- Posts showing intent to invest in SEO services\n\nEXCLUDE:\n- SEO specialists promoting their own services\n- Generic SEO news or algorithm update discussions\n- People looking for SEO jobs\n- Posts selling SEO tools or courses\n\nDATA:\nPost Content: [[TEXT]]\n\nReply with exactly YES on the FIRST LINE if this person is a potential SEO client. Reply NO otherwise.\nOn the SECOND LINE and beyond, explain your reasoning for the decision.",
        matchWord: "yes",
        matchScope: "first_line",
      },
    },
  },

  video_editor_client_acquisition: {
    meta: {
      name: { en: "Video Editor Leads" },
      desc: { en: "Find businesses needing video editing services" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Video Editor Lead Gen" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Content creators and businesses looking for video editors",
        keywords: "need video editor\nlooking for video editor\nhire video editor\nneed someone to edit my videos\nlooking for short form editor\nneed reels editor\nneed tiktok editor\nhire youtube editor\nneed premiere pro editor\nlooking for after effects expert\nneed davinci resolve editor\nvideo editor wanted\nlooking for freelance video editor\nneed content repurposing editor\nhelp editing my podcast clips\nneed talking head editor\nlooking for instagram video editor\nwho can edit my tiktoks\nneed long form video editor\nhire video production help\nneed someone to cut my videos\nlooking for motion graphics editor\nneed subtitles and captions editor\nwho does video editing for creators\nneed gaming video editor\nlooking for corporate video editor",
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Keep only posts from real people/businesses actively looking to hire a video editor",
        aiPrompt: "You are analyzing a Facebook post to find potential video editing clients.\n\nLOOK FOR:\n- Creators/business owners asking for video editor recommendations\n- People looking to hire freelance or full-time video editors\n- Posts specifying video editing needs (reels, tiktok, youtube, etc.)\n\nEXCLUDE:\n- Video editors promoting their own services\n- People looking for video editing jobs\n- Generic posts about video production\n\nDATA:\nPost Content: [[TEXT]]\n\nReply with exactly YES on the FIRST LINE if this person needs a video editor. Reply NO otherwise.\nOn the SECOND LINE and beyond, explain your reasoning for the decision.",
        matchWord: "yes",
        matchScope: "first_line",
      },
    },
  },

  email_marketing_client_acquisition: {
    meta: {
      name: { en: "Email Marketing Leads" },
      desc: { en: "Find businesses needing email marketing help" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Email Marketing Lead Gen" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Business owners looking for email marketing or newsletter help",
        keywords: "need email marketing help\nlooking for email copywriter\nhelp with newsletter\nemail marketing not converting\nlooking for klaviyo expert\nneed mailchimp setup\nemail sequences not working\nhire email marketing specialist\nneed abandoned cart emails\nlooking for email automation\nwho does email marketing for ecommerce\nneed drip campaign setup\nhelp with email deliverability\nlooking for retention marketing\nneed CRM email setup\nemail list not engaging\nhelp with welcome sequence\nneed newsletter writer\nlooking for email strategist\nneed email design help\nwho can write my emails\nlooking for activecampaign expert\nneed customer winback emails\nemail open rates dropped\nlooking for lifecycle marketing",
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Keep only posts from real business owners actively seeking email marketing help",
        aiPrompt: "You are analyzing a Facebook post to find potential email marketing clients.\n\nLOOK FOR:\n- Business owners asking for email marketing/CRM/platform recommendations\n- People frustrated with email performance or deliverability\n- Posts showing intent to hire email marketing specialist\n\nEXCLUDE:\n- Email marketers promoting their own services\n- People looking for email marketing jobs\n- Generic posts about email marketing tips\n\nDATA:\nPost Content: [[TEXT]]\n\nReply with exactly YES on the FIRST LINE if this person is a potential email marketing client. Reply NO otherwise.\nOn the SECOND LINE and beyond, explain your reasoning for the decision.",
        matchWord: "yes",
        matchScope: "first_line",
      },
    },
  },

  copywriters_client_acquisition: {
    meta: {
      name: { en: "Copywriter Leads" },
      desc: { en: "Find businesses needing copywriting services" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Copywriter Lead Gen" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Business owners looking for copywriters or content writers",
        keywords: "need copywriter\nlooking for copywriter\nhire content writer\nneed blog writer\nlooking for website copy\nneed sales page copy\nhelp with landing page copy\nlooking for email copywriter\nneed product descriptions writer\nhire ghostwriter\nneed VSL script writer\nlooking for direct response copywriter\nneed ad copy writer\nwho writes copy for funnels\nneed brand voice copy\nlooking for SEO copywriter\nneed technical writer\nhire UX writer\nneed social media caption writer\nlooking for conversion copywriter\nneed case study writer\nwho can write my website content\nlooking for white paper writer\nneed press release writer\nhire content strategist",
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Keep only posts from real businesses/people actively looking to hire a copywriter",
        aiPrompt: "You are analyzing a Facebook post to find potential copywriting clients.\n\nLOOK FOR:\n- Business owners asking for copywriter/content writer recommendations\n- People looking to hire for specific writing projects (sales pages, emails, blog)\n- Posts showing need for written content\n\nEXCLUDE:\n- Copywriters promoting their own services\n- People looking for writing jobs\n- Generic posts about writing tips\n\nDATA:\nPost Content: [[TEXT]]\n\nReply with exactly YES on the FIRST LINE if this person needs a copywriter. Reply NO otherwise.\nOn the SECOND LINE and beyond, explain your reasoning for the decision.",
        matchWord: "yes",
        matchScope: "first_line",
      },
    },
  },

  ai_agency_client_acquisition: {
    meta: {
      name: { en: "AI Agency Leads" },
      desc: { en: "Find businesses needing AI automation or AI agents" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "AI Agency Lead Gen" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Business owners looking for AI automation, chatbots, or AI agents",
        keywords: "need AI automation\nlooking for AI agent\nhelp with AI chatbot\nneed ChatGPT integration\nhire AI developer\nlooking for AI workflow\nautomate my business with AI\nneed AI customer service bot\nlooking for make.com expert\nneed n8n automation\nhelp with AI voice agent\nneed AI appointment setter\nlooking for AI solutions\nwant to implement AI in business\nwho builds AI agents\nneed custom GPT\nlooking for AI consultant\nhelp with AI lead generation\nneed AI email responder\nlooking for workflow automation\nneed zapier AI setup\nhelp with AI content generation\nneed chatbot for my website\nlooking for AI image generation\nneed AI data analysis\nwho does AI for small business",
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Keep only posts from real business owners actively seeking AI/automation help",
        aiPrompt: "You are analyzing a Facebook post to find potential AI agency clients.\n\nLOOK FOR:\n- Business owners asking for AI automation or chatbot recommendations\n- People looking to implement AI in their business processes\n- Posts showing intent to hire AI developers or consultants\n\nEXCLUDE:\n- AI developers/agencies promoting their own services\n- People looking for AI/tech jobs\n- Generic AI news or hype posts\n- People just experimenting with AI for fun\n\nDATA:\nPost Content: [[TEXT]]\n\nReply with exactly YES on the FIRST LINE if this person is a potential AI agency client. Reply NO otherwise.\nOn the SECOND LINE and beyond, explain your reasoning for the decision.",
        matchWord: "yes",
        matchScope: "first_line",
      },
    },
  },

  ux_ui_designers_client_acquisition: {
    meta: {
      name: { en: "UX/UI Design Leads" },
      desc: { en: "Find businesses needing UX/UI design" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "UX/UI Design Lead Gen" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Business owners looking for UX/UI designers",
        keywords: "need UX designer\nlooking for UI designer\nhire product designer\nneed app design\nlooking for figma designer\nhelp with user research\nneed wireframes\nlooking for prototype design\nneed website redesign\nhire UX researcher\nlooking for design system\nneed mobile app UI\nhelp with usability testing\nneed saas dashboard design\nlooking for interaction designer\nneed landing page design\nwho designs web apps\nneed customer journey mapping\nlooking for UX audit\nneed accessibility design\nhire UI developer\nneed design for startup\nlooking for user-centered design\nneed high fidelity mockups\nwho can design my app\nlooking for UX consultant",
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Keep only posts from real businesses actively looking for UX/UI design help",
        aiPrompt: "You are analyzing a Facebook post to find potential UX/UI design clients.\n\nLOOK FOR:\n- Business owners asking for UX/UI designer recommendations\n- Startups looking for product/app design help\n- Posts showing need for design services\n\nEXCLUDE:\n- Designers promoting their own services\n- People looking for design jobs\n- Generic design inspiration posts\n\nDATA:\nPost Content: [[TEXT]]\n\nReply with exactly YES on the FIRST LINE if this person needs UX/UI design. Reply NO otherwise.\nOn the SECOND LINE and beyond, explain your reasoning for the decision.",
        matchWord: "yes",
        matchScope: "first_line",
      },
    },
  },

  web_designers_client_acquisition: {
    meta: {
      name: { en: "Web Design Leads" },
      desc: { en: "Find businesses needing web design" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Web Design Lead Gen" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Business owners looking for web designers or website redesign",
        keywords: "need web designer\nlooking for website redesign\nhire web developer\nneed new website\nmy website looks outdated\nneed wordpress designer\nlooking for shopify designer\nneed landing page builder\nhelp with squarespace\nlooking for webflow expert\nneed responsive website\nwho builds websites for small business\nneed ecommerce website\nlooking for freelance web designer\nneed website makeover\nhelp with my company website\nneed portfolio website\nlooking for custom website\nneed website for my startup\nwho can fix my website\nneed business website built\nlooking for affordable web design\nneed quick website setup\nhire website designer\nlooking for local web designer",
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Keep only posts from real businesses actively looking for web design services",
        aiPrompt: "You are analyzing a Facebook post to find potential web design clients.\n\nLOOK FOR:\n- Business owners asking for web designer/developer recommendations\n- People complaining about their current website or needing a redesign\n- Posts showing intent to hire for website creation\n\nEXCLUDE:\n- Web designers promoting their own services\n- People looking for web design jobs\n- Generic web design inspiration posts\n\nDATA:\nPost Content: [[TEXT]]\n\nReply with exactly YES on the FIRST LINE if this person needs web design. Reply NO otherwise.\nOn the SECOND LINE and beyond, explain your reasoning for the decision.",
        matchWord: "yes",
        matchScope: "first_line",
      },
    },
  },

  motion_designers_client_acquisition: {
    meta: {
      name: { en: "Motion Design Leads" },
      desc: { en: "Find businesses needing motion design or animation" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Motion Design Lead Gen" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Business owners looking for motion designers or animators",
        keywords: "need motion designer\nlooking for animator\nhire after effects artist\nneed explainer video\nlooking for motion graphics\nneed logo animation\nhire 2d animator\nneed 3d animation\nlooking for blender artist\nneed character animation\nhire motion graphics designer\nneed animated ads\nlooking for lottie animation\nneed kinetic typography\nwho does animated explainers\nneed product animation\nlooking for visual effects\nneed promo video animated\nhire video animator\nneed social media animations\nlooking for motion design studio\nneed GIF animations\nwho can animate my logo\nlooking for UI animation\nneed cinematic motion graphics",
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Keep only posts from real businesses actively looking for motion design services",
        aiPrompt: "You are analyzing a Facebook post to find potential motion design clients.\n\nLOOK FOR:\n- Business owners asking for animator/motion designer recommendations\n- Posts looking for explainer videos, logo animations, or animated ads\n- Posts showing intent to hire animation talent\n\nEXCLUDE:\n- Motion designers promoting their own services\n- People looking for animation jobs\n- Generic animation inspiration posts\n\nDATA:\nPost Content: [[TEXT]]\n\nReply with exactly YES on the FIRST LINE if this person needs motion design. Reply NO otherwise.\nOn the SECOND LINE and beyond, explain your reasoning for the decision.",
        matchWord: "yes",
        matchScope: "first_line",
      },
    },
  },

  web_dev_nocode_client_acquisition: {
    meta: {
      name: { en: "Web Dev / No-Code Leads" },
      desc: { en: "Find businesses needing website development or no-code solutions" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Web Dev / No-Code Lead Gen" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Business owners looking for website development, no-code builders, or web apps",
        keywords: "need web developer\nlooking for web developer\nhire web developer\nneed website built\nlooking for wordpress developer\nneed shopify developer\nhire shopify expert\nneed webflow expert\nlooking for bubble developer\nneed no code expert\nhelp with webflow site\nneed custom website developer\nlooking for full stack developer\nneed frontend developer\nhire react developer\nneed landing page built\nlooking for website builder\nneed ecommerce website developed\nwho can build my app\nneed MVP built\nlooking for bubble.io expert\nneed make.com automation\nhelp with n8n workflow\nneed zapier setup\nwho builds websites for startups\nneed web app developer\nlooking for saas developer\nneed API integration\nhelp with website migration\nneed custom coded website\nlooking for affordable web developer",
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Keep only posts from real business owners actively seeking web development or no-code solutions",
        aiPrompt: "You are analyzing a Facebook post to find potential clients for web development or no-code services.\n\nLOOK FOR:\n- Business owners asking for web developer/agency recommendations\n- Entrepreneurs looking to build websites, web apps, or MVPs\n- People needing help with Webflow, Bubble, WordPress, Shopify, or similar platforms\n- Posts showing intent to hire for website or web app development\n- No-code automation requests (Make, n8n, Zapier)\n\nEXCLUDE:\n- Developers or agencies promoting their own services\n- People looking for web development jobs\n- Generic tech news or discussions\n\nDATA:\nPost Content: [[TEXT]]\n\nReply with exactly YES on the FIRST LINE if this person needs web development or no-code help. Reply NO otherwise.\nOn the SECOND LINE and beyond, explain your reasoning for the decision.",
        matchWord: "yes",
        matchScope: "first_line",
      },
    },
  },

  ppc_google_ads_client_acquisition: {
    meta: {
      name: { en: "Google Ads / PPC Leads" },
      desc: { en: "Find businesses looking specifically for Google Ads / PPC specialists" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "Google Ads / PPC Lead Gen" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Business owners looking for Google Ads, PPC, or search advertising help",
        keywords: "need google ads expert\nlooking for google ads specialist\nhire ppc manager\nneed google shopping ads\nhelp with google search ads\ngoogle ads not converting\nlooking for google ads freelancer\nneed search engine advertising\nhelp with google ads campaign\nwho manages google ads\nneed google ads audit\nlooking for certified google ads\nneed shopping feed optimization\nhelp with performance max\nneed google ads consultant\nhire ppc agency\nneed keyword research for ads\ngoogle ads cost too high\nneed conversion tracking setup\nlooking for google ads management\nneed search campaign setup\nhelp with quality score\nneed google ads remarketing\nlooking for display ads specialist\nneed youtube ads manager\nhire google ads strategist",
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Keep only posts from real business owners actively seeking Google Ads / PPC help",
        aiPrompt: "You are analyzing a Facebook post to find potential Google Ads / PPC clients.\n\nLOOK FOR:\n- Business owners asking for Google Ads/PPC specialist recommendations\n- People frustrated with Google Ads performance or costs\n- Posts looking for Google Shopping, Search, Display, or YouTube ads help\n- Ecommerce owners needing shopping feed or Performance Max help\n\nEXCLUDE:\n- PPC specialists/agencies promoting their own services\n- People looking for PPC jobs\n- Generic posts about digital marketing news\n\nDATA:\nPost Content: [[TEXT]]\n\nReply with exactly YES on the FIRST LINE if this person is a potential Google Ads client. Reply NO otherwise.\nOn the SECOND LINE and beyond, explain your reasoning for the decision.",
        matchWord: "yes",
        matchScope: "first_line",
      },
    },
  },

  tiktok_reels_creator_client_acquisition: {
    meta: {
      name: { en: "TikTok / Reels Creator Leads" },
      desc: { en: "Find businesses needing short-form video content creation" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "TikTok / Reels Creator Lead Gen" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Business owners looking for TikTok or Reels content creators",
        keywords: "need tiktok creator\nlooking for reels creator\nhire short form video creator\nneed someone to make tiktoks\nlooking for tiktok content creator\nneed reels for my business\nhire tiktok manager\nneed instagram reels creator\nlooking for short video content\nneed social media video creator\nwho creates tiktoks for brands\nneed UGC creator\nlooking for tiktok influencer manager\nneed viral video creator\nhire reels content maker\nneed someone to film reels\nlooking for short form editor and creator\nneed tiktok strategy\nhelp with reels content\nwho does tiktok for small business\nneed vertical video creator\nlooking for tiktok shop creator\nneed faceless tiktok creator\nhire tiktok growth specialist\nlooking for creative content maker",
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Keep only posts from real businesses actively seeking TikTok or Reels content creation help",
        aiPrompt: "You are analyzing a Facebook post to find potential clients for TikTok/Reels content creation.\n\nLOOK FOR:\n- Business owners asking for TikTok creator or Reels creator recommendations\n- People looking to hire someone to film/create short-form video content\n- Posts from brands wanting to start or grow on TikTok/Reels\n- UGC creator requests\n\nEXCLUDE:\n- Creators promoting their own services\n- People looking for content creation jobs\n- Generic posts about TikTok trends\n\nDATA:\nPost Content: [[TEXT]]\n\nReply with exactly YES on the FIRST LINE if this person needs a TikTok/Reels content creator. Reply NO otherwise.\nOn the SECOND LINE and beyond, explain your reasoning for the decision.",
        matchWord: "yes",
        matchScope: "first_line",
      },
    },
  },

  // ==================== FACEBOOK — OUTREACH / LEAD GEN (PL) ====================
  smm_client_acquisition_pl: {
    meta: {
      name: { pl: "Generowanie Leadów SMM" },
      desc: { pl: "Znajdź właścicieli firm w Polsce aktywnie szukających pomocy lub zmagających się z prowadzeniem social media." },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { pl: "Generowanie Leadów SMM" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Właściciele firm sfrustrowani brakiem efektów w social media lub aktywnie szukający pomocy/SMM",
        keywords: "szukam social media managera\npotrzebuję kogoś do prowadzenia instagrama\nzatrudnię social media managera\npolećcie specjalistę od SMM\nznacie kogoś dobrego od social media\npotrzebna pomoc z profilem na Facebooku\nszukam stratega na Instagram\nkto poprowadzi moje social media\nzlecę prowadzenie social media\npotrzebny copywriter i content creator\nsocial media manager poszukiwany\nzatrudnię managera social media\nszukam freelancera SMM\npotrzebny manager instagrama\npomoc w social media dla firmy\nkto ogarnia social media dla małych firm\npotrzebny ktoś do TikToka dla marki\nszukam pomocy z contentem na LinkedIn\npotrzebuję kogoś do rozwoju Instagrama\nzatrudnię freelancera social media\npomoc marketingowa dla mojej firmy\nszukam kogoś do reklam na Instagramie\nposzukiwany specjalista od Facebook Ads\nkto ogarnie moje social media\npotrzebny SMM dla sklepu internetowego\nszukam lokalnej pomocy do social media\nzatrudnię content managera\npotrzebuję kogoś do wrzucania postów\nspecjalista social media do wzięcia\nszukam do zatrudnienia eksperta od IG",
        advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 2 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Zostaw tylko posty od prawdziwych właścicieli firm, którzy wykazują intencję zatrudnienia lub autentycznie zmagają się z prowadzeniem swoich social media.",
        aiPrompt: "Analizujesz post na Facebooku, aby znaleźć potencjalnych klientów na usługi Social Media Marketingu (SMM) w Polsce.\n\nSZUKAJ:\n- Osób aktywnie proszących o rekomendacje lub chcących zatrudnić pomoc do social media\n- Właścicieli firm sfrustrowanych wynikami swoich działań (niskie zasięgi, spadki zaangażowania, brak czasu/wypalenie)\n- Właścicieli małych firm, którzy wyraźnie prowadzą biznes, ale mają trudności z samodzielnym marketingiem\n\nWYKLUCZ:\n- Innych social media managerów lub agencje reklamujące swoje własne usługi\n- Generyczne posty motywacyjne lub poradnikowe o marketingu\n- Osoby narzekające na social media jako prywatni użytkownicy, a nie jako przedsiębiorcy\n- Osoby szukające pracy (freelancerów ogłaszających swoje usługi SMM)\n- Posty, które są wyraźnymi reklamami innych produktów lub usług\n\nDANE:\nTreść posta: [[TEXT]]\n\nOdpowiedz dokładnie słowem TAK w PIERWSZEJ LINII, jeśli ta osoba jest potencjalnym klientem SMM, z którym warto się skontaktować. W przeciwnym razie odpowiedz NIE.\nW DRUGIEJ LINII i kolejnych wyjaśnij swoje rozumowanie decyzji.",
        matchWord: "tak",
        matchScope: "first_line",
      },
    },
  },

  digital_marketing_client_acquisition_pl: {
    meta: {
      name: { pl: "Leady Digital Marketing" },
      desc: { pl: "Znajdź właścicieli firm szukających pomocy z Meta/Google Ads" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { pl: "Generowanie Leadów Digital Marketing" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Właściciele firm szukający pomocy z płatnymi reklamami",
        keywords: "szukam eksperta od facebook ads\npotrzebuję specjalisty google ads\nzatrudnię media buyera\npotrzebuję pomocy z meta ads\nfacebook ads nie konwertują\npolećcie dobrego ads managera\nkto poprowadzi moje reklamy\npotrzebny ppc specialist\nszukam performance marketera\npomoc z banem konta reklamowego\npotrzebuję kogoś do poprawy ROAS\nreklamy przestały działać\nspecjalista google ads potrzebny\nfreelancer meta ads poszukiwany\nszukam media buyera do współpracy\npotrzebna pomoc z kreacjami reklamowymi\nkampania nie jest rentowna\npotrzebuję konfiguracji facebook pixela\nkto ogarnia google ads dla małych firm\npotrzebna pomoc ze śledzeniem konwersji\nszukam eksperta od paid social\nbudżet reklamowy marnowany\npotrzebuję skalować reklamy\nszukam konsultanta facebook ads\nzatrudnię agencję performance marketing",
        advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Zostaw tylko posty od prawdziwych właścicieli firm aktywnie szukających pomocy z płatnymi reklamami",
        aiPrompt: "Analizujesz post na Facebooku, aby znaleźć potencjalnych klientów na usługi digital marketingu / płatnych reklam w Polsce.\n\nSZUKAJ:\n- Właścicieli firm proszących o rekomendacje specjalistów Facebook/Google Ads\n- Osób sfrustrowanych wynikami reklam (wysokie koszty, brak konwersji, zbanowane konta)\n- Przedsiębiorców szukających media buyerów lub performance marketerów\n- Postów pokazujących intencję wydania pieniędzy na reklamy, ale brakuje im wiedzy\n\nWYKLUCZ:\n- Innych marketerów lub agencje promujące własne usługi reklamowe\n- Generyczne posty o nowinkach w digital marketingu\n- Osób szukających pracy jako media buyer\n- Postów będących wyraźnymi reklamami kursów lub narzędzi\n\nDANE:\nTreść posta: [[TEXT]]\n\nOdpowiedz dokładnie TAK w PIERWSZEJ LINII, jeśli ta osoba jest potencjalnym klientem digital marketingu. W przeciwnym razie odpowiedz NIE.\nW DRUGIEJ LINII i kolejnych wyjaśnij swoje rozumowanie decyzji.",
        matchWord: "tak",
        matchScope: "first_line",
      },
    },
  },

  seo_client_acquisition_pl: {
    meta: {
      name: { pl: "Leady SEO" },
      desc: { pl: "Znajdź właścicieli firm szukających usług SEO" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { pl: "Generowanie Leadów SEO" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Właściciele firm szukający pomocy SEO lub narzekający na niski ruch",
        keywords: "szukam eksperta SEO\npotrzebuję specjalisty SEO\nruch na stronie spadł\nnie pozycjonuję się w Google\nzatrudnię konsultanta SEO\npomoc z rankingami wyszukiwania\npotrzebuję linkowania zwrotnego\nruch organiczny zniknął\naktualizacja Google uderzyła w moją stronę\npotrzebuję audytu SEO\npolećcie agencję SEO\nkto robi SEO dla małych firm\npotrzebuję wyższych pozycji\nstrona nie ma odwiedzin\nszukam pomocy z lokalnym SEO\npotrzebuję researchu słów kluczowych\npomoc z Google Moja Firma\nSEO nie działa na mojej stronie\npotrzebuję kogoś do naprawy SEO\nszukam freelancera SEO\nstrona straciła cały ruch po aktualizacji\npotrzebna pomoc z on-page SEO\npomoc z technicznym SEO\nkto zrobi SEO dla mojego sklepu\nszukam white hat SEO\npotrzebny ekspert ecommerce SEO",
        advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Zostaw tylko posty od prawdziwych właścicieli firm aktywnie szukających pomocy SEO",
        aiPrompt: "Analizujesz post na Facebooku, aby znaleźć potencjalnych klientów SEO w Polsce.\n\nSZUKAJ:\n- Właścicieli firm proszących o rekomendacje SEO lub szukających do zatrudnienia\n- Osób sfrustrowanych niskim ruchem na stronie lub spadkami w Google\n- Przedsiębiorców, którzy rozumieją, że mają problem z SEO\n- Postów pokazujących intencję inwestycji w usługi SEO\n\nWYKLUCZ:\n- Specjalistów SEO promujących własne usługi\n- Generyczne dyskusje o nowinkach SEO lub aktualizacjach algorytmu\n- Osób szukających pracy w SEO\n- Postów sprzedających narzędzia lub kursy SEO\n\nDANE:\nTreść posta: [[TEXT]]\n\nOdpowiedz dokładnie TAK w PIERWSZEJ LINII, jeśli ta osoba jest potencjalnym klientem SEO. W przeciwnym razie odpowiedz NIE.\nW DRUGIEJ LINII i kolejnych wyjaśnij swoje rozumowanie decyzji.",
        matchWord: "tak",
        matchScope: "first_line",
      },
    },
  },

  video_editor_client_acquisition_pl: {
    meta: {
      name: { pl: "Leady Montaż Wideo" },
      desc: { pl: "Znajdź firmy potrzebujące usług montażu wideo" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { pl: "Generowanie Leadów Montaż Wideo" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Twórcy i firmy szukający montażystów wideo",
        keywords: "szukam montażysty wideo\npotrzebuję kogoś do montażu filmów\nzatrudnię montażystę\npotrzebuję kogoś do zmontowania moich filmów\nszukam montażysty short form\npotrzebny montażysta rolek\npotrzebny montażysta tik tok\nzatrudnię montażystę youtube\npotrzebny montażysta premiere pro\nszukam eksperta after effects\npotrzebny montażysta davinci resolve\nmontażysta wideo poszukiwany\nszukam freelancera montażysty\npotrzebny montażysta do contentu\npomoc z montażem podcastów\npotrzebny montażysta talking head\nszukam montażysty instagram\nkto zmontuje moje tiktoki\npotrzebny montażysta long form\nzatrudnię pomoc do produkcji wideo\npotrzebuję kogoś do cięcia filmów\nszukam montażysty motion graphics\npotrzebny montażysta napisów\nkto montuje filmy dla twórców\npotrzebny montażysta gaming\nszukam montażysty korporacyjnego",
        advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Zostaw tylko posty od osób/firm aktywnie szukających montażysty wideo",
        aiPrompt: "Analizujesz post na Facebooku, aby znaleźć potencjalnych klientów na montaż wideo w Polsce.\n\nSZUKAJ:\n- Twórców/właścicieli firm proszących o rekomendacje montażysty\n- Osób szukających montażysty freelancera lub na pełen etat\n- Postów precyzujących potrzeby montażowe (rolki, tiktok, youtube itp.)\n\nWYKLUCZ:\n- Montażystów promujących własne usługi\n- Osób szukających pracy jako montażysta\n- Generycznych postów o produkcji wideo\n\nDANE:\nTreść posta: [[TEXT]]\n\nOdpowiedz dokładnie TAK w PIERWSZEJ LINII, jeśli ta osoba potrzebuje montażysty. W przeciwnym razie odpowiedz NIE.\nW DRUGIEJ LINII i kolejnych wyjaśnij swoje rozumowanie decyzji.",
        matchWord: "tak",
        matchScope: "first_line",
      },
    },
  },

  email_marketing_client_acquisition_pl: {
    meta: {
      name: { pl: "Leady Email Marketing" },
      desc: { pl: "Znajdź firmy potrzebujące pomocy z email marketingiem" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { pl: "Generowanie Leadów Email Marketing" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Właściciele firm szukający pomocy z email marketingiem lub newsletterem",
        keywords: "szukam pomocy z email marketingiem\npotrzebny email copywriter\npomoc z newsletterem\nemail marketing nie konwertuje\nszukam eksperta klaviyo\npotrzebna konfiguracja mailchimp\nsekwencje email nie działają\nzatrudnię specjalistę email marketingu\npotrzebne porzucone koszyki\nszukam automatyzacji email\nkto robi email marketing dla ecommerce\npotrzebna kampania drip\npomoc z dostarczalnością emaili\nszukam retention marketingu\npotrzebna konfiguracja CRM email\nlista email nie angażuje\npomoc z sekwencją powitalną\npotrzebny autor newslettera\nszukam stratega email\npotrzebny projektant emaili\nkto napisze moje maile\nszukam eksperta activecampaign\npotrzebne maile winback\nopen rate spadł\nszukam lifecycle marketingu",
        advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Zostaw tylko posty od prawdziwych właścicieli firm aktywnie szukających pomocy z email marketingiem",
        aiPrompt: "Analizujesz post na Facebooku, aby znaleźć potencjalnych klientów email marketingu w Polsce.\n\nSZUKAJ:\n- Właścicieli firm proszących o rekomendacje platform/marketingowców email\n- Osób sfrustrowanych wynikami emaili lub dostarczalnością\n- Postów pokazujących intencję zatrudnienia specjalisty email marketingu\n\nWYKLUCZ:\n- Marketingowców email promujących własne usługi\n- Osób szukających pracy w email marketingu\n- Generycznych postów z poradami o email marketingu\n\nDANE:\nTreść posta: [[TEXT]]\n\nOdpowiedz dokładnie TAK w PIERWSZEJ LINII, jeśli ta osoba jest potencjalnym klientem. W przeciwnym razie odpowiedz NIE.\nW DRUGIEJ LINII i kolejnych wyjaśnij swoje rozumowanie decyzji.",
        matchWord: "tak",
        matchScope: "first_line",
      },
    },
  },

  copywriters_client_acquisition_pl: {
    meta: {
      name: { pl: "Leady Copywriting" },
      desc: { pl: "Znajdź firmy potrzebujące usług copywritingu" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { pl: "Generowanie Leadów Copywriting" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Właściciele firm szukający copywriterów lub autorów treści",
        keywords: "szukam copywritera\npotrzebny copywriter\nzatrudnię autora treści\npotrzebny pisarz blogowy\nszukam tekstów na stronę\npotrzebny tekst strony sprzedażowej\npomoc z tekstem landing page\nszukam email copywritera\npotrzebne opisy produktów\nzatrudnię ghostwritera\npotrzebny scenarzysta VSL\nszukam copywritera direct response\npotrzebny autor tekstów reklamowych\nkto pisze teksty pod lejki\npotrzebny brand voice\nszukam copywritera SEO\npotrzebny technical writer\nzatrudnię UX writera\npotrzebny autor napisów social media\nszukam copywritera konwersyjnego\npotrzebny autor case studies\nkto napisze treści na moją stronę\nszukam autora white paper\npotrzebny autor komunikatów prasowych\nzatrudnię stratega treści",
        advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Zostaw tylko posty od firm/osób aktywnie szukających copywritera",
        aiPrompt: "Analizujesz post na Facebooku, aby znaleźć potencjalnych klientów copywritingu w Polsce.\n\nSZUKAJ:\n- Właścicieli firm proszących o rekomendacje copywriterów/autorek\n- Osób szukających do konkretnych projektów pisarskich (strony sprzedażowe, maile, blog)\n- Postów pokazujących zapotrzebowanie na treści pisane\n\nWYKLUCZ:\n- Copywriterów promujących własne usługi\n- Osób szukających pracy jako autor\n- Generycznych postów z poradami o pisaniu\n\nDANE:\nTreść posta: [[TEXT]]\n\nOdpowiedz dokładnie TAK w PIERWSZEJ LINII, jeśli ta osoba potrzebuje copywritera. W przeciwnym razie odpowiedz NIE.\nW DRUGIEJ LINII i kolejnych wyjaśnij swoje rozumowanie decyzji.",
        matchWord: "tak",
        matchScope: "first_line",
      },
    },
  },

  ai_agency_client_acquisition_pl: {
    meta: {
      name: { pl: "Leady AI Agency" },
      desc: { pl: "Znajdź firmy potrzebujące automatyzacji AI lub agentów AI" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { pl: "Generowanie Leadów AI Agency" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Właściciele firm szukający automatyzacji AI, chatbotów lub agentów AI",
        keywords: "szukam automatyzacji AI\npotrzebny agent AI\npomoc z chatbotem AI\npotrzebna integracja ChatGPT\nzatrudnię developera AI\nszukam workflow AI\nautomatyzacja firmy z AI\npotrzebny bot AI do obsługi klienta\nszukam eksperta make.com\npotrzebna automatyzacja n8n\npomoc z voice agent AI\npotrzebny AI appointment setter\nszukam rozwiązań AI\nchcę wdrożyć AI w firmie\nkto buduje agentów AI\npotrzebny custom GPT\nszukam konsultanta AI\npomoc z AI lead generation\npotrzebny autoresponder AI\nszukam automatyzacji workflow\npotrzebna konfiguracja zapier AI\npomoc z generowaniem treści AI\npotrzebny chatbot na stronę\nszukam generowania obrazów AI\npotrzebna analiza danych AI\nkto robi AI dla małych firm",
        advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Zostaw tylko posty od prawdziwych firm aktywnie szukających pomocy z AI/automatyzacją",
        aiPrompt: "Analizujesz post na Facebooku, aby znaleźć potencjalnych klientów agencji AI w Polsce.\n\nSZUKAJ:\n- Właścicieli firm proszących o rekomendacje automatyzacji AI lub chatbotów\n- Osób chcących wdrożyć AI w procesach biznesowych\n- Postów pokazujących intencję zatrudnienia developerów lub konsultantów AI\n\nWYKLUCZ:\n- Developerów/agencji AI promujących własne usługi\n- Osób szukających pracy w AI/tech\n- Generycznych postów o nowinkach AI\n- Osób tylko eksperymentujących z AI dla zabawy\n\nDANE:\nTreść posta: [[TEXT]]\n\nOdpowiedz dokładnie TAK w PIERWSZEJ LINII, jeśli ta osoba jest potencjalnym klientem agencji AI. W przeciwnym razie odpowiedz NIE.\nW DRUGIEJ LINII i kolejnych wyjaśnij swoje rozumowanie decyzji.",
        matchWord: "tak",
        matchScope: "first_line",
      },
    },
  },

  ux_ui_designers_client_acquisition_pl: {
    meta: {
      name: { pl: "Leady UX/UI Design" },
      desc: { pl: "Znajdź firmy potrzebujące UX/UI designu" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { pl: "Generowanie Leadów UX/UI Design" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Właściciele firm szukający projektantów UX/UI",
        keywords: "szukam UX designera\npotrzebny UI designer\nzatrudnię product designera\npotrzebny projekt aplikacji\nszukam designera figma\npomoc z badaniem użytkowników\npotrzebne makiety\nszukam prototypowania\npotrzebny redesign strony\nzatrudnię UX researchera\nszukam design system\npotrzebne UI aplikacji mobilnej\npomoc z testowaniem użyteczności\npotrzebny design dashboardu SaaS\nszukam interaction designera\npotrzebny projekt landing page\nkto projektuje aplikacje webowe\npotrzebne mapowanie podróży klienta\nszukam audytu UX\npotrzebny design dostępności\nzatrudnię UI developera\npotrzebny design dla startupu\nszukam projektowania zorientowanego na użytkownika\npotrzebne makiety high fidelity\nkto zaprojektuje moją aplikację\nszukam konsultanta UX",
        advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Zostaw tylko posty od firm aktywnie szukających pomocy z UX/UI designem",
        aiPrompt: "Analizujesz post na Facebooku, aby znaleźć potencjalnych klientów UX/UI designu w Polsce.\n\nSZUKAJ:\n- Właścicieli firm proszących o rekomendacje projektantów UX/UI\n- Startupów szukających pomocy z projektowaniem produktów/aplikacji\n- Postów pokazujących zapotrzebowanie na usługi projektowe\n\nWYKLUCZ:\n- Projektantów promujących własne usługi\n- Osób szukających pracy w designie\n- Generycznych postów z inspiracjami designu\n\nDANE:\nTreść posta: [[TEXT]]\n\nOdpowiedz dokładnie TAK w PIERWSZEJ LINII, jeśli ta osoba potrzebuje UX/UI designu. W przeciwnym razie odpowiedz NIE.\nW DRUGIEJ LINII i kolejnych wyjaśnij swoje rozumowanie decyzji.",
        matchWord: "tak",
        matchScope: "first_line",
      },
    },
  },

  web_designers_client_acquisition_pl: {
    meta: {
      name: { pl: "Leady Web Design" },
      desc: { pl: "Znajdź firmy potrzebujące web designu" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { pl: "Generowanie Leadów Web Design" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Właściciele firm szukający projektantów stron lub redesignu",
        keywords: "szukam web designera\npotrzebny redesign strony\nzatrudnię web developera\npotrzebna nowa strona\nmoja strona wygląda przestarzałe\npotrzebny wordpress designer\nszukam shopify designera\npotrzebny landing page builder\npomoc z squarespace\nszukam eksperta webflow\npotrzebna responsywna strona\nkto buduje strony dla małych firm\npotrzebna strona ecommerce\nszukam freelancera web designu\npotrzebny makeover strony\npomoc ze stroną firmową\npotrzebna strona portfolio\nszukam strony custom\npotrzebna strona dla startupu\nkto naprawi moją stronę\npotrzebna strona biznesowa\nszukam taniego web designu\npotrzebna szybka strona\nzatrudnię projektanta stron\nszukam lokalnego web designera",
        advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Zostaw tylko posty od firm aktywnie szukających usług web designu",
        aiPrompt: "Analizujesz post na Facebooku, aby znaleźć potencjalnych klientów web designu w Polsce.\n\nSZUKAJ:\n- Właścicieli firm proszących o rekomendacje projektantów/developerów\n- Osób narzekających na obecną stronę lub potrzebujących redesignu\n- Postów pokazujących intencję zatrudnienia do stworzenia strony\n\nWYKLUCZ:\n- Projektantów promujących własne usługi\n- Osób szukających pracy w web designie\n- Generycznych postów z inspiracjami web designu\n\nDANE:\nTreść posta: [[TEXT]]\n\nOdpowiedz dokładnie TAK w PIERWSZEJ LINII, jeśli ta osoba potrzebuje web designu. W przeciwnym razie odpowiedz NIE.\nW DRUGIEJ LINII i kolejnych wyjaśnij swoje rozumowanie decyzji.",
        matchWord: "tak",
        matchScope: "first_line",
      },
    },
  },

  motion_designers_client_acquisition_pl: {
    meta: {
      name: { pl: "Leady Motion Design" },
      desc: { pl: "Znajdź firmy potrzebujące motion designu lub animacji" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { pl: "Generowanie Leadów Motion Design" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Właściciele firm szukający motion designerów lub animatorów",
        keywords: "szukam motion designera\npotrzebny animator\nzatrudnię artystę after effects\npotrzebny film wyjaśniający\nszukam motion graphics\npotrzebna animacja logo\nzatrudnię animatora 2d\npotrzebna animacja 3d\nszukam artysty blender\npotrzebna animacja postaci\nzatrudnię motion graphics designera\npotrzebne animowane reklamy\nszukam animacji lottie\npotrzebna typografia kinetyczna\nkto robi animowane explainery\npotrzebna animacja produktu\nszukam efektów wizualnych\npotrzebny animowany film promocyjny\nzatrudnię animatora wideo\npotrzebne animacje social media\nszukam studia motion design\npotrzebne animacje GIF\nkto zanimuje moje logo\nszukam animacji UI\npotrzebny cinematic motion graphics",
        advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Zostaw tylko posty od firm aktywnie szukających usług motion designu",
        aiPrompt: "Analizujesz post na Facebooku, aby znaleźć potencjalnych klientów motion designu w Polsce.\n\nSZUKAJ:\n- Właścicieli firm proszących o rekomendacje animatorów/motion designerów\n- Postów szukających filmów wyjaśniających, animacji logo lub animowanych reklam\n- Postów pokazujących intencję zatrudnienia talentu animacyjnego\n\nWYKLUCZ:\n- Motion designerów promujących własne usługi\n- Osób szukających pracy w animacji\n- Generycznych postów z inspiracjami animacji\n\nDANE:\nTreść posta: [[TEXT]]\n\nOdpowiedz dokładnie TAK w PIERWSZEJ LINII, jeśli ta osoba potrzebuje motion designu. W przeciwnym razie odpowiedz NIE.\nW DRUGIEJ LINII i kolejnych wyjaśnij swoje rozumowanie decyzji.",
        matchWord: "tak",
        matchScope: "first_line",
      },
    },
  },

  web_dev_nocode_client_acquisition_pl: {
    meta: {
      name: { pl: "Leady Web Dev / No-Code" },
      desc: { pl: "Znajdź firmy potrzebujące stron internetowych lub rozwiązań no-code" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { pl: "Generowanie Leadów Web Dev / No-Code" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Właściciele firm szukający programistów stron, specjalistów no-code lub aplikacji webowych",
        keywords: "szukam web developera\npotrzebny programista stron\nzatrudnię web developera\npotrzebna strona internetowa\nszukam wordpress developera\npotrzebny shopify developer\nzatrudnię eksperta shopify\npotrzebny ekspert webflow\nszukam bubble developera\npotrzebny specjalista no code\npomoc ze stroną webflow\npotrzebny custom website developer\nszukam full stack developera\npotrzebny frontend developer\nzatrudnię react developera\npotrzebny landing page\nszukam kreatora stron\npotrzebny sklep internetowy\nkto zbuduje moją aplikację\npotrzebny MVP\nszukam eksperta bubble.io\npotrzebna automatyzacja make.com\npomoc z workflow n8n\npotrzebna konfiguracja zapier\nkto buduje strony dla startupów\nszukam web app developera\npotrzebny saas developer\npotrzebna integracja API\npomoc z migracją strony\nszukam taniego web developera",
        advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Zostaw tylko posty od prawdziwych firm szukających web developmentu lub rozwiązań no-code",
        aiPrompt: "Analizujesz post na Facebooku, aby znaleźć potencjalnych klientów na usługi web developmentu i no-code.\n\nSZUKAJ:\n- Właścicieli firm proszących o rekomendacje programistów/agencji\n- Przedsiębiorców chcących zbudować strony, aplikacje webowe lub MVP\n- Osób potrzebujących pomocy z Webflow, Bubble, WordPress, Shopify itp.\n- Postów pokazujących intencję zatrudnienia do budowy strony lub aplikacji\n- Zleceń na automatyzację no-code (Make, n8n, Zapier)\n\nWYKLUCZ:\n- Programistów lub agencji promujących własne usługi\n- Osób szukających pracy w web dev\n- Generycznych dyskusji o technologii\n\nDANE:\nTreść posta: [[TEXT]]\n\nOdpowiedz dokładnie TAK w PIERWSZEJ LINII, jeśli ta osoba potrzebuje web developmentu lub no-code. W przeciwnym razie NIE.\nW DRUGIEJ LINII i kolejnych wyjaśnij swoje rozumowanie decyzji.",
        matchWord: "tak",
        matchScope: "first_line",
      },
    },
  },

  ppc_google_ads_client_acquisition_pl: {
    meta: {
      name: { pl: "Leady Google Ads / PPC" },
      desc: { pl: "Znajdź firmy szukające specjalistów Google Ads / PPC" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { pl: "Generowanie Leadów Google Ads / PPC" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Właściciele firm szukający specjalistów Google Ads, PPC lub reklamy w wyszukiwarce",
        keywords: "szukam eksperta google ads\npotrzebny specjalista google ads\nzatrudnię ppc managera\npotrzebne google shopping ads\npomoc z google search ads\ngoogle ads nie konwertują\nszukam freelancera google ads\npotrzebna reklama w wyszukiwarce\npomoc z kampanią google ads\nkto zarządza google ads\npotrzebny audyt google ads\nszukam certifikowanego google ads\npotrzebna optymalizacja shopping feed\npomoc z performance max\npotrzebny konsultant google ads\nzatrudnię agencję ppc\npotrzebny research słów kluczowych\ngoogle ads kosztuje za dużo\npotrzebna konfiguracja śledzenia konwersji\nszukam zarządzania google ads\npotrzebna kampania search\npomoc z quality score\npotrzebny remarketing google ads\nszukam specjalisty display ads\npotrzebny youtube ads manager\nzatrudnię stratega google ads",
        advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Zostaw tylko posty od prawdziwych firm aktywnie szukających pomocy z Google Ads / PPC",
        aiPrompt: "Analizujesz post na Facebooku, aby znaleźć potencjalnych klientów Google Ads / PPC w Polsce.\n\nSZUKAJ:\n- Właścicieli firm proszących o rekomendacje specjalistów Google Ads/PPC\n- Osób sfrustrowanych wynikami Google Ads lub kosztami\n- Postów szukających pomocy z Google Shopping, Search, Display lub YouTube Ads\n- Właścicieli ecommerce potrzebujących pomocy z shopping feed lub Performance Max\n\nWYKLUCZ:\n- Specjalistów PPC/agencji promujących własne usługi\n- Osób szukających pracy w PPC\n- Generycznych postów o nowinkach marketingu\n\nDANE:\nTreść posta: [[TEXT]]\n\nOdpowiedz dokładnie TAK w PIERWSZEJ LINII, jeśli ta osoba jest potencjalnym klientem Google Ads. W przeciwnym razie NIE.\nW DRUGIEJ LINII i kolejnych wyjaśnij swoje rozumowanie decyzji.",
        matchWord: "tak",
        matchScope: "first_line",
      },
    },
  },

  tiktok_reels_creator_client_acquisition_pl: {
    meta: {
      name: { pl: "Leady TikTok / Reels Creator" },
      desc: { pl: "Znajdź firmy potrzebujące tworzenia krótkich treści wideo" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { pl: "Generowanie Leadów TikTok / Reels Creator" },
      scraping: {
        selectedSocial: "facebook",
        selectedPlatform: "facebook_posts",
        whoToFind: "Właściciele firm szukający twórców TikTok lub Reels",
        keywords: "szukam twórcy tiktok\npotrzebny twórca rolek\nzatrudnię kreatora short form video\npotrzebuję kogoś do tiktoków\nszukam content creatora tiktok\npotrzebne rolki dla mojej firmy\nzatrudnię managera tiktok\npotrzebny twórca instagram reels\nszukam krótkich treści wideo\npotrzebny kreator wideo social media\nkto tworzy tiktoki dla marek\npotrzebny UGC creator\nszukam managera influencerów tiktok\npotrzebny twórca viral video\nzatrudnię kreatora rolek\npotrzebuję kogoś do nagrywania rolek\nszukam montażysty i kreatora short form\npotrzebna strategia tiktok\npomoc z treściami reels\nkto robi tiktoka dla małych firm\npotrzebny kreator vertical video\nszukam twórcy tiktok shop\npotrzebny faceless tiktok creator\nzatrudnię specjalistę wzrostu tiktok\nszukam kreatywnego twórcy treści",
        advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Zostaw tylko posty od firm aktywnie szukających pomocy z tworzeniem treści TikTok/Reels",
        aiPrompt: "Analizujesz post na Facebooku, aby znaleźć potencjalnych klientów na tworzenie treści TikTok/Reels w Polsce.\n\nSZUKAJ:\n- Właścicieli firm proszących o rekomendacje twórców TikTok/Reels\n- Osób szukających kogoś do nagrywania/tworzenia krótkich treści wideo\n- Postów od marek chcących zacząć lub rozwinąć się na TikTok/Reels\n- Zleceń na UGC creator\n\nWYKLUCZ:\n- Twórców promujących własne usługi\n- Osób szukających pracy jako twórca treści\n- Generycznych postów o trendach TikTok\n\nDANE:\nTreść posta: [[TEXT]]\n\nOdpowiedz dokładnie TAK w PIERWSZEJ LINII, jeśli ta osoba potrzebuje twórcy TikTok/Reels. W przeciwnym razie NIE.\nW DRUGIEJ LINII i kolejnych wyjaśnij swoje rozumowanie decyzji.",
        matchWord: "tak",
        matchScope: "first_line",
      },
    },
  },

  // ==================== LINKEDIN — COMMENTING FOCUS (EN) ====================
  linkedin_smm_commenting: {
    meta: {
      name: { en: "LinkedIn SMM — Commenting Targets" },
      desc: { en: "Find LinkedIn posts in SMM niche worth commenting on to build authority" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "LinkedIn SMM Commenting" },
      scraping: {
        selectedSocial: "linkedin",
        selectedPlatform: "linkedin_posts",
        whoToFind: "LinkedIn posts about social media marketing where your comment adds value",
        keywords: "social media strategy\nInstagram tips\norganic reach\nsocial media trends\nbest time to post\ncontent calendar\nsocial media ROI\nengagement hacks\ngrow on Instagram\nlinkedin content tips\nsocial media manager life\ntiktok for business\nsocial selling\npersonal branding tips\ncontent creation tips\nsocial media algorithm\ncommunity management\nsocial media tools\nshort form video tips\nsocial media metrics\nposting frequency\nhashtag strategy\nsocial media burnout\nclient social media\nb2b social media",
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Find LinkedIn posts where a thoughtful comment from an SMM expert would get engagement and build authority",
        aiPrompt: "You are analyzing LinkedIn posts to find commenting opportunities for an SMM expert.\n\nLOOK FOR:\n- Posts asking questions about social media strategy, tools, or tactics\n- Posts sharing opinions where a counter-perspective adds value\n- Posts where the author clearly wants discussion (ends with 'what do you think?' etc.)\n- Posts from business owners struggling with social media (you can add value)\n- Hot takes or controversial opinions about SMM (high engagement potential)\n\nEXCLUDE:\n- Self-promotional posts from other SMMs\n- Job postings or hiring announcements\n- Posts that are just links to articles with no discussion\n- Posts that already have 100+ comments (too late to stand out)\n\nDATA:\nPost Content: [[TEXT]]\nAuthor: [[AUTHOR]]\nEngagement: [[LIKES]] likes, [[COMMENTS]] comments\n\nReply with exactly YES on the FIRST LINE if this is a great commenting opportunity. Reply NO otherwise.\nOn the SECOND LINE and beyond, explain your reasoning for the decision.",
        matchWord: "yes",
        matchScope: "first_line",
      },
    },
  },

  linkedin_digital_marketing_commenting: {
    meta: {
      name: { en: "LinkedIn Digital Marketing — Commenting" },
      desc: { en: "Find posts about paid ads to comment on and build authority" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "LinkedIn Paid Ads Commenting" },
      scraping: {
        selectedSocial: "linkedin",
        selectedPlatform: "linkedin_posts",
        whoToFind: "LinkedIn posts about Meta/Google ads with commenting potential",
        keywords: "facebook ads tips\ngoogle ads strategy\nmeta ads performance\nROAS optimization\nad creative testing\nperformance marketing\ntargeting tips\nad account banned\nfacebook ads scaling\ngoogle ads bidding\nppc strategy\nconversion tracking\nretargeting strategy\nad copy that works\nlanding page CRO\nmedia buying\nad budget allocation\nfacebook ads algorithm\ngoogle performance max\nad fatigue fix\nlookalike audiences\ncampaign structure\nattribution models\ncost per acquisition\nad creative trends",
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Find posts about paid ads where commenting builds authority as a performance marketer",
        aiPrompt: "You are analyzing LinkedIn posts to find commenting opportunities for a paid ads expert.\n\nLOOK FOR:\n- Posts asking questions about ad strategy, scaling, or optimization\n- People sharing ad results and asking for feedback\n- Controversial takes about ad platforms (high engagement)\n- Posts where business owners complain about ad costs (you can add value)\n- Discussions about new ad features or platform changes\n\nEXCLUDE:\n- Self-promotional posts from agencies\n- Job postings\n- Posts that are just case study bragging with no discussion\n- Posts with 100+ comments already\n\nDATA:\nPost Content: [[TEXT]]\nEngagement: [[LIKES]] likes, [[COMMENTS]] comments\n\nReply with exactly YES on the FIRST LINE if this is a great commenting opportunity. Reply NO otherwise.\nOn the SECOND LINE and beyond, explain your reasoning for the decision.",
        matchWord: "yes",
        matchScope: "first_line",
      },
    },
  },

  linkedin_seo_commenting: {
    meta: {
      name: { en: "LinkedIn SEO — Commenting" },
      desc: { en: "Find SEO-related posts to comment on and build authority" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "LinkedIn SEO Commenting" },
      scraping: {
        selectedSocial: "linkedin",
        selectedPlatform: "linkedin_posts",
        whoToFind: "LinkedIn posts about SEO where commenting builds your expert profile",
        keywords: "SEO strategy\nGoogle algorithm update\nkeyword research tips\nbacklink building\nSEO vs AI\norganic traffic\ncontent SEO\ntechnical SEO\necommerce SEO\nlocal SEO tips\nSERP features\nSEO tools review\nsite migration SEO\nSEO predictions\nGoogle ranking factor\nSEO career\nlink building strategy\nSEO content writing\nSEO for startups\nsearch console insights",
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Find SEO-related posts where a thoughtful comment builds authority and gets engagement",
        aiPrompt: "You are analyzing LinkedIn posts to find commenting opportunities for an SEO expert.\n\nLOOK FOR:\n- Posts asking SEO questions or seeking advice\n- Discussions about Google updates or algorithm changes\n- Hot takes about SEO (great for adding nuance)\n- People sharing SEO struggles you can help with\n- Posts debating SEO best practices\n\nEXCLUDE:\n- Self-promotional agency posts\n- Job listings\n- Posts with 100+ comments already\n- Pure news shares without discussion hooks\n\nDATA:\nPost Content: [[TEXT]]\nEngagement: [[LIKES]] likes, [[COMMENTS]] comments\n\nReply with exactly YES on the FIRST LINE if this is a good commenting opportunity. Reply NO otherwise.\nOn the SECOND LINE and beyond, explain your reasoning for the decision.",
        matchWord: "yes",
        matchScope: "first_line",
      },
    },
  },

  linkedin_video_editing_commenting: {
    meta: {
      name: { en: "LinkedIn Video Editing — Commenting" },
      desc: { en: "Find posts about video production to engage with" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "LinkedIn Video Editing Commenting" },
      scraping: {
        selectedSocial: "linkedin",
        selectedPlatform: "linkedin_posts",
        whoToFind: "LinkedIn posts about video editing, content creation tools, video trends",
        keywords: "video editing tips\npremiere pro tutorial\nfinal cut pro\ncapcut trends\nshort form video\nvideo content strategy\nmotion graphics\nvideo editing workflow\nAI video tools\nvideo editing career\nfreelance video editing\nvideo retention tips\nyoutube editing\nreels editing tips\ntiktok editing tricks\ncolor grading\nsound design video\nvideo editing software\nhiring video editor\nvideo marketing ROI",
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Find video-related posts where a pro editor's comment adds value and gets noticed",
        aiPrompt: "You are analyzing LinkedIn posts to find commenting opportunities for a video editor.\n\nLOOK FOR:\n- Posts asking about video editing tools, techniques, or workflows\n- Creators sharing editing struggles you can help with\n- Discussions about AI in video editing (hot topic)\n- Posts about video content strategy where editing is key\n- Debates about editing software\n\nEXCLUDE:\n- Self-promotional posts from editors\n- Job postings\n- Posts with 100+ comments already\n- Pure portfolio showcases with no discussion\n\nDATA:\nPost Content: [[TEXT]]\nEngagement: [[LIKES]] likes, [[COMMENTS]] comments\n\nReply with exactly YES on the FIRST LINE. Reply NO otherwise.\nOn the SECOND LINE and beyond, explain your reasoning for the decision.",
        matchWord: "yes",
        matchScope: "first_line",
      },
    },
  },

  linkedin_email_marketing_commenting: {
    meta: {
      name: { en: "LinkedIn Email Marketing — Commenting" },
      desc: { en: "Find email marketing discussions to build authority" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "LinkedIn Email Marketing Commenting" },
      scraping: {
        selectedSocial: "linkedin",
        selectedPlatform: "linkedin_posts",
        whoToFind: "LinkedIn posts about email marketing, newsletters, deliverability",
        keywords: "email marketing strategy\nnewsletter growth\nemail deliverability\nklaviyo tips\nemail copywriting\nemail automation\nopen rate improvement\nemail design best practices\ncold email outreach\nemail list building\nretention marketing\nemail segmentation\nA/B testing email\nemail personalization\nGDPR email compliance\nwelcome email sequence\nabandoned cart emails\nemail metrics\nemail vs social\nnewsletter monetization",
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Find email marketing posts where commenting builds authority",
        aiPrompt: "You are analyzing LinkedIn posts to find commenting opportunities for an email marketing expert.\n\nLOOK FOR:\n- Posts asking email marketing questions\n- Discussions about deliverability, strategy, or tools\n- Hot takes about email marketing trends\n- People sharing email struggles\n\nEXCLUDE:\n- Self-promotion, job posts, posts with 100+ comments\n\nDATA:\nPost Content: [[TEXT]]\nEngagement: [[LIKES]] likes, [[COMMENTS]] comments\n\nReply with exactly YES on the FIRST LINE. Reply NO otherwise.\nOn the SECOND LINE and beyond, explain your reasoning for the decision.",
        matchWord: "yes",
        matchScope: "first_line",
      },
    },
  },

  linkedin_copywriting_commenting: {
    meta: {
      name: { en: "LinkedIn Copywriting — Commenting" },
      desc: { en: "Find copywriting discussions to engage with" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "LinkedIn Copywriting Commenting" },
      scraping: {
        selectedSocial: "linkedin",
        selectedPlatform: "linkedin_posts",
        whoToFind: "LinkedIn posts about copywriting, conversion copy, brand voice",
        keywords: "copywriting tips\nconversion copywriting\ndirect response copy\nbrand voice guide\nheadline formulas\nsales page copy\nemail copy tips\nAIDA framework\ncopywriting mistakes\nstorytelling in copy\nUX writing\ncopywriting frameworks\npersuasive writing\ncopywriting trends\nSEO copywriting\nlanding page copy\ncreative copywriting\ncopywriter life\nAI copywriting tools\ncopywriting portfolio",
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Find copywriting posts where an expert comment adds value and gets seen",
        aiPrompt: "You are analyzing LinkedIn posts to find commenting opportunities for a copywriter.\n\nLOOK FOR:\n- Posts asking copywriting questions or for feedback\n- Debates about copywriting techniques\n- Hot takes on AI copywriting tools\n- Posts sharing copywriting struggles\n\nEXCLUDE:\n- Self-promotion, job posts, posts with 100+ comments\n\nDATA:\nPost Content: [[TEXT]]\nEngagement: [[LIKES]] likes, [[COMMENTS]] comments\n\nReply with exactly YES on the FIRST LINE. Reply NO otherwise.\nOn the SECOND LINE and beyond, explain your reasoning for the decision.",
        matchWord: "yes",
        matchScope: "first_line",
      },
    },
  },

  linkedin_ai_agency_commenting: {
    meta: {
      name: { en: "LinkedIn AI Agency — Commenting" },
      desc: { en: "Find AI/automation discussions to build authority" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "LinkedIn AI Agency Commenting" },
      scraping: {
        selectedSocial: "linkedin",
        selectedPlatform: "linkedin_posts",
        whoToFind: "LinkedIn posts about AI agents, automation, no-code, ChatGPT",
        keywords: "AI agents for business\nmake.com automation\nn8n workflow\nchatgpt for business\nAI customer service\ncustom GPTs\nAI lead generation\nAI automation trends\nno code AI\nvoice AI agents\nAI workflows\nGPT store\nAI chatbot development\nAI consulting\nAI for SMB\nautomation ROI\nAI vs human\nAI agency model\nAI tools comparison\nLLM for business",
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Find AI/automation posts where expert comments get high engagement",
        aiPrompt: "You are analyzing LinkedIn posts to find commenting opportunities for an AI agency expert.\n\nLOOK FOR:\n- Posts asking about AI implementation or tools\n- Debates about AI replacing humans (high engagement)\n- People sharing AI struggles or successes\n- Discussions about AI ethics, practical use cases\n\nEXCLUDE:\n- Self-promotion, job posts, posts with 100+ comments\n\nDATA:\nPost Content: [[TEXT]]\nEngagement: [[LIKES]] likes, [[COMMENTS]] comments\n\nReply with exactly YES on the FIRST LINE. Reply NO otherwise.\nOn the SECOND LINE and beyond, explain your reasoning for the decision.",
        matchWord: "yes",
        matchScope: "first_line",
      },
    },
  },

  linkedin_design_commenting: {
    meta: {
      name: { en: "LinkedIn Design — Commenting" },
      desc: { en: "Find design-related posts to engage with" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { en: "LinkedIn Design Commenting" },
      scraping: {
        selectedSocial: "linkedin",
        selectedPlatform: "linkedin_posts",
        whoToFind: "LinkedIn posts about UX, UI, web design, branding",
        keywords: "UX design tips\nUI design trends\nfigma tips\nbrand identity design\ndesign thinking\nweb design trends\ndesign systems\naccessibility design\nmotion design\nproduct design\nsaas design\ndesign portfolio\ndesign career\ndesign feedback\nAI in design\ndesign process\ntypography design\ncolor theory\ndesign critique\nuser research methods",
        advancedSettings: { searchLanguage: "en", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Find design posts where expert comments build authority and get engagement",
        aiPrompt: "You are analyzing LinkedIn posts to find commenting opportunities for a designer.\n\nLOOK FOR:\n- Posts asking design questions or for feedback\n- Discussions about design tools, trends, or AI in design\n- Hot takes about design (great for engagement)\n- People sharing design challenges\n\nEXCLUDE:\n- Self-promotion, job posts, posts with 100+ comments\n- Pure portfolio posts with no discussion hook\n\nDATA:\nPost Content: [[TEXT]]\nEngagement: [[LIKES]] likes, [[COMMENTS]] comments\n\nReply with exactly YES on the FIRST LINE. Reply NO otherwise.\nOn the SECOND LINE and beyond, explain your reasoning for the decision.",
        matchWord: "yes",
        matchScope: "first_line",
      },
    },
  },

  // ==================== LINKEDIN — COMMENTING FOCUS (PL) ====================
  linkedin_smm_commenting_pl: {
    meta: {
      name: { pl: "LinkedIn SMM — Cele komentowania" },
      desc: { pl: "Znajdź posty na LinkedIn o SMM warte skomentowania, by budować autorytet" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { pl: "LinkedIn SMM Komentowanie" },
      scraping: {
        selectedSocial: "linkedin",
        selectedPlatform: "linkedin_posts",
        whoToFind: "Posty na LinkedIn o social media marketingu, gdzie twój komentarz doda wartości",
        keywords: "strategia social media\nporady Instagram\nzasięgi organiczne\ntrendy social media\nnajlepszy czas na post\nkalendarz treści\nROI social media\nhakowanie zaangażowania\njak rosnąć na Instagramie\nporady LinkedIn content\nżycie social media managera\ntiktok dla biznesu\nsocial selling\nporady personal branding\ntworzenie treści\nalgorytm social media\nzarządzanie społecznością\nnarzędzia social media\nporady short form video\nmetryki social media\nczęstotliwość publikacji\nstrategia hashtagów\nwypalenie social media\nsocial media klienta\nb2b social media",
        advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Znajdź posty LinkedIn, gdzie przemyślany komentarz eksperta SMM zdobędzie zaangażowanie i zbuduje autorytet",
        aiPrompt: "Analizujesz posty na LinkedIn, aby znaleźć okazje do komentowania dla eksperta SMM.\n\nSZUKAJ:\n- Postów z pytaniami o strategię social media, narzędzia lub taktyki\n- Postów dzielących się opiniami, gdzie przeciwna perspektywa doda wartości\n- Postów, gdzie autor wyraźnie chce dyskusji (kończy się 'co myślicie?' itp.)\n- Postów właścicieli firm zmagających się z social media (możesz dodać wartość)\n- Gorących tematów lub kontrowersyjnych opinii o SMM (wysoki potencjał zaangażowania)\n\nWYKLUCZ:\n- Posty autopromocyjne innych SMM-owców\n- Ogłoszenia o pracę\n- Posty będące tylko linkami do artykułów bez dyskusji\n- Posty które już mają 100+ komentarzy (za późno by się wyróżnić)\n\nDANE:\nTreść posta: [[TEXT]]\nAutor: [[AUTHOR]]\nZaangażowanie: [[LIKES]] polubień, [[COMMENTS]] komentarzy\n\nOdpowiedz dokładnie TAK w PIERWSZEJ LINII, jeśli to świetna okazja do komentowania. W przeciwnym razie NIE.\nW DRUGIEJ LINII i kolejnych wyjaśnij swoje rozumowanie decyzji.",
        matchWord: "tak",
        matchScope: "first_line",
      },
    },
  },

  linkedin_digital_marketing_commenting_pl: {
    meta: {
      name: { pl: "LinkedIn Digital Marketing — Komentowanie" },
      desc: { pl: "Znajdź posty o płatnych reklamach do skomentowania i budowania autorytetu" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { pl: "LinkedIn Paid Ads Komentowanie" },
      scraping: {
        selectedSocial: "linkedin",
        selectedPlatform: "linkedin_posts",
        whoToFind: "Posty na LinkedIn o Meta/Google Ads z potencjałem do komentowania",
        keywords: "porady facebook ads\nstrategia google ads\nwyniki meta ads\noptymalizacja ROAS\ntestowanie kreacji reklamowych\nperformance marketing\nporady targetowanie\nzbanowane konto reklamowe\nskalowanie facebook ads\ngoogle ads licytacja\nstrategia ppc\nśledzenie konwersji\nstrategia retargetingu\nteksty reklamowe które działają\nlanding page CRO\nmedia buying\nbudżet reklamowy\nalgorytm facebook ads\ngoogle performance max\nzmęczenie reklam\nlookalike audiences\nkampania struktura\nmodele atrybucji\nkoszt pozyskania\ntrendy kreacji reklamowych",
        advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Znajdź posty o płatnych reklamach gdzie komentowanie buduje autorytet jako performance marketer",
        aiPrompt: "Analizujesz posty na LinkedIn, aby znaleźć okazje do komentowania dla eksperta paid ads.\n\nSZUKAJ:\n- Postów z pytaniami o strategię reklamową, skalowanie lub optymalizację\n- Osób dzielących się wynikami reklam i proszących o feedback\n- Kontrowersyjnych opinii o platformach reklamowych (wysokie zaangażowanie)\n- Postów gdzie właściciele firm narzekają na koszty reklam (możesz dodać wartość)\n- Dyskusji o nowych funkcjach reklamowych lub zmianach platform\n\nWYKLUCZ:\n- Posty autopromocyjne agencji\n- Ogłoszenia o pracę\n- Posty będące tylko chwaleniem się case study bez dyskusji\n- Posty z już 100+ komentarzami\n\nDANE:\nTreść posta: [[TEXT]]\nZaangażowanie: [[LIKES]] polubień, [[COMMENTS]] komentarzy\n\nOdpowiedz dokładnie TAK w PIERWSZEJ LINII, jeśli to świetna okazja. W przeciwnym razie NIE.\nW DRUGIEJ LINII i kolejnych wyjaśnij swoje rozumowanie decyzji.",
        matchWord: "tak",
        matchScope: "first_line",
      },
    },
  },

  linkedin_seo_commenting_pl: {
    meta: {
      name: { pl: "LinkedIn SEO — Komentowanie" },
      desc: { pl: "Znajdź posty związane z SEO do skomentowania i budowania autorytetu" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { pl: "LinkedIn SEO Komentowanie" },
      scraping: {
        selectedSocial: "linkedin",
        selectedPlatform: "linkedin_posts",
        whoToFind: "Posty na LinkedIn o SEO gdzie komentowanie buduje twój profil eksperta",
        keywords: "strategia SEO\naktualizacja algorytmu Google\nporady keyword research\nbudowanie linków\nSEO vs AI\nruch organiczny\ncontent SEO\nSEO techniczne\necommerce SEO\nlokalne SEO porady\nSERP features\nrecenzje narzędzi SEO\nmigracja strony SEO\nprognozy SEO\nGoogle ranking factor\nkariera SEO\nstrategia linkowania\npisanie treści SEO\nSEO dla startupów\nsearch console porady",
        advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Znajdź posty SEO gdzie przemyślany komentarz buduje autorytet i zdobywa zaangażowanie",
        aiPrompt: "Analizujesz posty na LinkedIn, aby znaleźć okazje do komentowania dla eksperta SEO.\n\nSZUKAJ:\n- Postów z pytaniami SEO lub szukających porady\n- Dyskusji o aktualizacjach Google lub zmianach algorytmu\n- Gorących tematów o SEO (świetne do dodania niuansów)\n- Osób dzielących się problemami SEO, z którymi możesz pomóc\n- Postów debatujących o najlepszych praktykach SEO\n\nWYKLUCZ:\n- Posty autopromocyjne agencji\n- Ogłoszenia o pracę\n- Posty z już 100+ komentarzami\n- Czyste udostępnianie newsów bez haczyków dyskusyjnych\n\nDANE:\nTreść posta: [[TEXT]]\nZaangażowanie: [[LIKES]] polubień, [[COMMENTS]] komentarzy\n\nOdpowiedz dokładnie TAK w PIERWSZEJ LINII, jeśli to dobra okazja. W przeciwnym razie NIE.\nW DRUGIEJ LINII i kolejnych wyjaśnij swoje rozumowanie decyzji.",
        matchWord: "tak",
        matchScope: "first_line",
      },
    },
  },

  linkedin_video_editing_commenting_pl: {
    meta: {
      name: { pl: "LinkedIn Montaż Wideo — Komentowanie" },
      desc: { pl: "Znajdź posty o produkcji wideo do zaangażowania" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { pl: "LinkedIn Montaż Wideo Komentowanie" },
      scraping: {
        selectedSocial: "linkedin",
        selectedPlatform: "linkedin_posts",
        whoToFind: "Posty na LinkedIn o montażu wideo, narzędziach, trendach",
        keywords: "porady montaż wideo\npremiere pro tutorial\nfinal cut pro\ncapcut trendy\nshort form video\nstrategia treści wideo\nmotion graphics\nworkflow montażu\nnarzędzia AI wideo\nkariera montażysty\nfreelance montaż wideo\nporady retencja wideo\nmontaż youtube\nporady reels montaż\ntiktok sztuczki montażowe\nkorekcja kolorów\nsound design wideo\noprogramowanie do montażu\nzatrudnienie montażysty\nROI video marketingu",
        advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Znajdź posty o wideo gdzie komentarz profesjonalnego montażysty dodaje wartości i zostaje zauważony",
        aiPrompt: "Analizujesz posty na LinkedIn, aby znaleźć okazje do komentowania dla montażysty.\n\nSZUKAJ:\n- Postów z pytaniami o narzędzia, techniki lub workflow montażu\n- Twórców dzielących się problemami z montażem, z którymi możesz pomóc\n- Dyskusji o AI w montażu (gorący temat)\n- Postów o strategii treści wideo gdzie montaż jest kluczowy\n- Debat o oprogramowaniu do montażu\n\nWYKLUCZ:\n- Posty autopromocyjne montażystów\n- Ogłoszenia o pracę\n- Posty z już 100+ komentarzami\n- Czyste portfolio showcase bez dyskusji\n\nDANE:\nTreść posta: [[TEXT]]\nZaangażowanie: [[LIKES]] polubień, [[COMMENTS]] komentarzy\n\nOdpowiedz dokładnie TAK w PIERWSZEJ LINII. W przeciwnym razie NIE.\nW DRUGIEJ LINII i kolejnych wyjaśnij swoje rozumowanie decyzji.",
        matchWord: "tak",
        matchScope: "first_line",
      },
    },
  },

  linkedin_email_marketing_commenting_pl: {
    meta: {
      name: { pl: "LinkedIn Email Marketing — Komentowanie" },
      desc: { pl: "Znajdź dyskusje o email marketingu do budowania autorytetu" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { pl: "LinkedIn Email Marketing Komentowanie" },
      scraping: {
        selectedSocial: "linkedin",
        selectedPlatform: "linkedin_posts",
        whoToFind: "Posty na LinkedIn o email marketingu, newsletterach, dostarczalności",
        keywords: "strategia email marketingu\nwzrost newslettera\ndostarczalność emaili\nporady klaviyo\ncopywriting email\nautomatyzacja email\npoprawa open rate\nnajlepsze praktyki projektowania emaili\ncold email outreach\nbudowanie listy email\nretention marketing\nsegmentacja email\nA/B testowanie email\npersonalizacja email\nGDPR email zgodność\nsekwencja welcome\nporzucone koszyki email\nmetryki email\nemail vs social\nmonetyzacja newslettera",
        advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Znajdź posty email marketingowe gdzie komentowanie buduje autorytet",
        aiPrompt: "Analizujesz posty na LinkedIn, aby znaleźć okazje do komentowania dla eksperta email marketingu.\n\nSZUKAJ:\n- Postów z pytaniami o email marketing\n- Dyskusji o dostarczalności, strategii lub narzędziach\n- Gorących tematów o trendach email marketingu\n- Osób dzielących się problemami z emailami\n\nWYKLUCZ:\n- Autopromocja, ogłoszenia o pracę, posty z 100+ komentarzami\n\nDANE:\nTreść posta: [[TEXT]]\nZaangażowanie: [[LIKES]] polubień, [[COMMENTS]] komentarzy\n\nOdpowiedz dokładnie TAK w PIERWSZEJ LINII. W przeciwnym razie NIE.\nW DRUGIEJ LINII i kolejnych wyjaśnij swoje rozumowanie decyzji.",
        matchWord: "tak",
        matchScope: "first_line",
      },
    },
  },

  linkedin_copywriting_commenting_pl: {
    meta: {
      name: { pl: "LinkedIn Copywriting — Komentowanie" },
      desc: { pl: "Znajdź dyskusje o copywritingu do zaangażowania" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { pl: "LinkedIn Copywriting Komentowanie" },
      scraping: {
        selectedSocial: "linkedin",
        selectedPlatform: "linkedin_posts",
        whoToFind: "Posty na LinkedIn o copywritingu, copy konwersyjnym, brand voice",
        keywords: "porady copywriting\ncopywriting konwersyjny\ndirect response copy\nbrand voice poradnik\nformuły nagłówków\nteksty strony sprzedażowej\nporady email copy\nframework AIDA\nbłędy copywritingu\nstorytelling w copy\nUX writing\nframeworki copywritingu\nperswazyjne pisanie\ntrendy copywritingu\nSEO copywriting\nteksty landing page\nkreatywny copywriting\nżycie copywritera\nnarzędzia AI copywriting\nportfolio copywritera",
        advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Znajdź posty copywriterskie gdzie ekspercki komentarz dodaje wartości i zostaje zauważony",
        aiPrompt: "Analizujesz posty na LinkedIn, aby znaleźć okazje do komentowania dla copywritera.\n\nSZUKAJ:\n- Postów z pytaniami o copywriting lub proszących o feedback\n- Debat o technikach copywritingu\n- Gorących tematów o narzędziach AI do copywritingu\n- Postów dzielących się problemami z copywritingiem\n\nWYKLUCZ:\n- Autopromocja, ogłoszenia o pracę, posty z 100+ komentarzami\n\nDANE:\nTreść posta: [[TEXT]]\nZaangażowanie: [[LIKES]] polubień, [[COMMENTS]] komentarzy\n\nOdpowiedz dokładnie TAK w PIERWSZEJ LINII. W przeciwnym razie NIE.\nW DRUGIEJ LINII i kolejnych wyjaśnij swoje rozumowanie decyzji.",
        matchWord: "tak",
        matchScope: "first_line",
      },
    },
  },

  linkedin_ai_agency_commenting_pl: {
    meta: {
      name: { pl: "LinkedIn AI Agency — Komentowanie" },
      desc: { pl: "Znajdź dyskusje o AI/automatyzacji do budowania autorytetu" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { pl: "LinkedIn AI Agency Komentowanie" },
      scraping: {
        selectedSocial: "linkedin",
        selectedPlatform: "linkedin_posts",
        whoToFind: "Posty na LinkedIn o agentach AI, automatyzacji, no-code, ChatGPT",
        keywords: "agenci AI dla biznesu\nautomatyzacja make.com\nworkflow n8n\nchatgpt dla biznesu\nobsługa klienta AI\ncustom GPTs\nAI lead generation\ntrendy automatyzacji AI\nno code AI\nvoice AI agenci\nworkflows AI\nGPT store\nchatbot development\nkonsulting AI\nAI dla MSP\nautomatyzacja ROI\nAI vs człowiek\nmodel agencji AI\nporównanie narzędzi AI\nLLM dla biznesu",
        advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Znajdź posty AI/automatyzacji gdzie eksperckie komentarze zdobywają wysokie zaangażowanie",
        aiPrompt: "Analizujesz posty na LinkedIn, aby znaleźć okazje do komentowania dla eksperta agencji AI.\n\nSZUKAJ:\n- Postów z pytaniami o wdrożenie AI lub narzędzia\n- Debat o AI zastępującej ludzi (wysokie zaangażowanie)\n- Osób dzielących się problemami lub sukcesami z AI\n- Dyskusji o etyce AI, praktycznych przypadkach użycia\n\nWYKLUCZ:\n- Autopromocja, ogłoszenia o pracę, posty z 100+ komentarzami\n\nDANE:\nTreść posta: [[TEXT]]\nZaangażowanie: [[LIKES]] polubień, [[COMMENTS]] komentarzy\n\nOdpowiedz dokładnie TAK w PIERWSZEJ LINII. W przeciwnym razie NIE.\nW DRUGIEJ LINII i kolejnych wyjaśnij swoje rozumowanie decyzji.",
        matchWord: "tak",
        matchScope: "first_line",
      },
    },
  },

  linkedin_design_commenting_pl: {
    meta: {
      name: { pl: "LinkedIn Design — Komentowanie" },
      desc: { pl: "Znajdź posty związane z designem do zaangażowania" },
      badge: "scraping+filtering",
    },
    prefill: {
      taskType: "scraping+filtering",
      taskName: { pl: "LinkedIn Design Komentowanie" },
      scraping: {
        selectedSocial: "linkedin",
        selectedPlatform: "linkedin_posts",
        whoToFind: "Posty na LinkedIn o UX, UI, web designie, brandingu",
        keywords: "porady UX design\ntrendy UI design\nporady figma\ndesign identyfikacji marki\ndesign thinking\ntrendy web design\nsystemy designu\ndesign dostępności\nmotion design\nproduct design\nsaas design\nportfolio designera\nkariera designera\nfeedback designu\nAI w designie\nproces designu\ntypografia design\nteoria koloru\nkrytyka designu\nuser research metody",
        advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 3 },
        scheduleType: "once",
        parseAuthorPages: false,
      },
      filtering: {
        rules: [],
        matchType: "any",
        useAI: true,
        aiGoal: "Znajdź posty o designie gdzie eksperckie komentarze budują autorytet i zdobywają zaangażowanie",
        aiPrompt: "Analizujesz posty na LinkedIn, aby znaleźć okazje do komentowania dla designera.\n\nSZUKAJ:\n- Postów z pytaniami o design lub proszących o feedback\n- Dyskusji o narzędziach, trendach lub AI w designie\n- Gorących tematów o designie (świetne do zaangażowania)\n- Osób dzielących się wyzwaniami projektowymi\n\nWYKLUCZ:\n- Autopromocja, ogłoszenia o pracę, posty z 100+ komentarzami\n- Czyste portfolio posts bez haczyka dyskusyjnego\n\nDANE:\nTreść posta: [[TEXT]]\nZaangażowanie: [[LIKES]] polubień, [[COMMENTS]] komentarzy\n\nOdpowiedz dokładnie TAK w PIERWSZEJ LINII. W przeciwnym razie NIE.\nW DRUGIEJ LINII i kolejnych wyjaśnij swoje rozumowanie decyzji.",
        matchWord: "tak",
        matchScope: "first_line",
      },
    },
  },






  // ==================== INSTAGRAM REELS — ПОЛЬСКИЕ ВЕРСИИ ВСЕХ КАТЕГОРИЙ ====================

instagram_reels_ugc_creators_pl: {
  meta: {
    name: { pl: "Twórcy UGC" },
    desc: { pl: "Znajdź twórców treści generowanych przez użytkowników dla marek" },
    badge: "scraping+filtering",
  },
  prefill: {
    taskType: "scraping+filtering",
    taskName: { pl: "Rolki twórców UGC" },
    scraping: {
      selectedSocial: "instagram", selectedPlatform: "instagram_reels",
      whoToFind: "Twórcy UGC tworzący autentyczne treści dla marek",
      keywords: 'ugc creator\ntwórca ugc\ntreści generowane przez użytkowników\nportfolio ugc\nwspółpraca z marką\nprzykład ugc\ntwórca treści do wynajęcia',
      advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 10 },
      scheduleType: "once", parseAuthorPages: false,
    },
    filtering: {
      rules: [], matchType: "all", useAI: true,
      aiGoal: "Filtruj twórców UGC",
      aiPrompt: "", aiMiddlePart: "Sprawdź [[USER_BIO]] i [[USER_SCREENSHOT]]. Czy to twórca UGC, który tworzy autentyczne filmy produktowe dla marek? Szukaj linków do portfolio, 'UGC' w bio, przykładów współpracy z markami.\n\nOdpowiedz 'tak' lub 'nie'.",
      matchWord: "tak", matchScope: "first_line",
      reelsMetrics: {
        enabled: true, minViews: "2000", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
        minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 25,
        sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
        summaryPrompt: "Przeanalizuj te rolki UGC. Jakie typy produktów są prezentowane? Jakie style nagrywania działają najlepiej? Zidentyfikuj trendy w tworzeniu autentycznych treści.",
        _summaryPromptInitialized: true, filterMethods: ["user_profile"],
      },
      _aiPromptInitialized: false,
    },
  },
},

instagram_reels_ecommerce_fashion_pl: {
  meta: {
    name: { pl: "Marki modowe i odzieżowe" },
    desc: { pl: "Znajdź marki modowe, butiki, sklepy odzieżowe na Reels" },
    badge: "scraping+filtering",
  },
  prefill: {
    taskType: "scraping+filtering",
    taskName: { pl: "Rolki marek modowych" },
    scraping: {
      selectedSocial: "instagram", selectedPlatform: "instagram_reels",
      whoToFind: "Marki modowe i sklepy odzieżowe publikujące rolki",
      keywords: 'nowa kolekcja\ninspiracja stylizacją\nhaul modowy\nstreetwear\nzrównoważona moda\nmarka odzieżowa\nzakupy w butiku',
      advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 15 },
      scheduleType: "once", parseAuthorPages: false,
    },
    filtering: {
      rules: [], matchType: "all", useAI: true,
      aiGoal: "Filtruj marki modowe",
      aiPrompt: "", aiMiddlePart: "Sprawdź [[USER_BIO]], [[USER_SCREENSHOT]] i [[REELS_INFO_TEXT]]. Czy to marka modowa, sklep odzieżowy lub butik, który sprzedaje produkty? Szukaj linków do sklepu, informacji o rozmiarach, zapowiedzi produktów.\n\nOdpowiedz 'tak' lub 'nie'.",
      matchWord: "tak", matchScope: "first_line",
      reelsMetrics: {
        enabled: true, minViews: "3000", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
        minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 30,
        sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
        summaryPrompt: "Przeanalizuj te rolki modowe. Jakie style są trendy? Które formaty zdobywają najwięcej zaangażowania (hauls, transformacje stylizacji, za kulisami)?",
        _summaryPromptInitialized: true, filterMethods: ["user_profile", "reel_info"],
      },
      _aiPromptInitialized: false,
    },
  },
},

instagram_reels_beauty_cosmetics_pl: {
  meta: {
    name: { pl: "Uroda i kosmetyki" },
    desc: { pl: "Znajdź marki kosmetyczne, pielęgnację skóry, makijaż na Reels" },
    badge: "scraping+filtering",
  },
  prefill: {
    taskType: "scraping+filtering",
    taskName: { pl: "Rolki marek kosmetycznych" },
    scraping: {
      selectedSocial: "instagram", selectedPlatform: "instagram_reels",
      whoToFind: "Marki kosmetyczne i pielęgnacyjne publikujące rolki",
      keywords: 'rutyna pielęgnacyjna\ntutorial makijażu\nprodukty kosmetyczne\nrecenzja kosmetyków\nkbeauty\nclean beauty\nrecenzja serum',
      advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 12 },
      scheduleType: "once", parseAuthorPages: false,
    },
    filtering: {
      rules: [], matchType: "all", useAI: true,
      aiGoal: "Filtruj marki kosmetyczne",
      aiPrompt: "", aiMiddlePart: "Sprawdź [[USER_BIO]], [[USER_FULLNAME]] i [[REELS_INFO_TEXT]]. Czy to marka kosmetyczna, linia pielęgnacyjna lub firma kosmetyczna? Szukaj wzmianek o produktach, składnikach, treści przed/po.\n\nOdpowiedz 'tak' lub 'nie'.",
      matchWord: "tak", matchScope: "first_line",
      reelsMetrics: {
        enabled: true, minViews: "5000", maxViews: "", minLikes: "100", maxLikes: "", minComments: "", maxComments: "",
        minEngagementRate: "2", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 30,
        sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
        summaryPrompt: "Przeanalizuj te rolki kosmetyczne. Jakie kategorie produktów dominują? Jakie style wideo działają najlepiej? Zidentyfikuj kluczowe czynniki zaangażowania.",
        _summaryPromptInitialized: true, filterMethods: ["user_profile", "reel_info"],
      },
      _aiPromptInitialized: false,
    },
  },
},

instagram_reels_home_decor_pl: {
  meta: {
    name: { pl: "Wystrój wnętrz i meble" },
    desc: { pl: "Znajdź projektantów wnętrz, marki dekoracji domowych na Reels" },
    badge: "scraping+filtering",
  },
  prefill: {
    taskType: "scraping+filtering",
    taskName: { pl: "Rolki wystroju wnętrz" },
    scraping: {
      selectedSocial: "instagram", selectedPlatform: "instagram_reels",
      whoToFind: "Marki dekoracji domowych i konta projektantów wnętrz",
      keywords: 'dekoracje domowe\nprojektowanie wnętrz\nmetamorfoza pokoju\nsklep meblowy\nhaul dekoracyjny\nzwiedzanie domu\ndekoracja mieszkania',
      advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["m"], maxPages: 10 },
      scheduleType: "once", parseAuthorPages: false,
    },
    filtering: {
      rules: [], matchType: "all", useAI: true,
      aiGoal: "Filtruj firmy z branży wystroju wnętrz",
      aiPrompt: "", aiMiddlePart: "Sprawdź [[USER_BIO]] i [[USER_SCREENSHOT]]. Czy to marka dekoracji domowych, sklep meblowy lub projektant wnętrz sprzedający produkty/usługi? Szukaj linków do sklepu, portfolio projektów, katalogów produktów.\n\nOdpowiedz 'tak' lub 'nie'.",
      matchWord: "tak", matchScope: "first_line",
      reelsMetrics: {
        enabled: true, minViews: "3000", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
        minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 25,
        sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
        summaryPrompt: "Przeanalizuj te rolki o wystroju wnętrz. Jakie style są trendy? Które typy pomieszczeń zdobywają najwięcej wyświetleń? Zidentyfikuj popularne formaty dekoracyjne.",
        _summaryPromptInitialized: true, filterMethods: ["user_profile"],
      },
      _aiPromptInitialized: false,
    },
  },
},

instagram_reels_food_restaurants_pl: {
  meta: {
    name: { pl: "Restauracje i firmy spożywcze" },
    desc: { pl: "Znajdź restauracje, kawiarnie, marki spożywcze na Reels" },
    badge: "scraping+filtering",
  },
  prefill: {
    taskType: "scraping+filtering",
    taskName: { pl: "Rolki firm spożywczych" },
    scraping: {
      selectedSocial: "instagram", selectedPlatform: "instagram_reels",
      whoToFind: "Restauracje, kawiarnie i firmy spożywcze",
      keywords: 'restauracja\njedzenie kawiarniane\nfoodie\njedzenie uliczne\npiekarnia\ncukiernia\nbrunch\nfirma spożywcza',
      advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 12 },
      scheduleType: "once", parseAuthorPages: false,
    },
    filtering: {
      rules: [], matchType: "all", useAI: true,
      aiGoal: "Filtruj firmy spożywcze",
      aiPrompt: "", aiMiddlePart: "Sprawdź [[USER_BIO]], [[USER_FULLNAME]] i [[REELS_INFO_TEXT]]. Czy to restauracja, kawiarnia, piekarnia lub marka spożywcza? Szukaj wzmianek o menu, tagów lokalizacji, linków do zamówień, zdjęć jedzenia.\n\nOdpowiedz 'tak' lub 'nie'.",
      matchWord: "tak", matchScope: "first_line",
      reelsMetrics: {
        enabled: true, minViews: "2000", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
        minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 30,
        sortBy: "views", needFilter: true, needDescription: true, generateSummary: true,
        summaryPrompt: "Przeanalizuj te rolki kulinarne. Jakie kuchnie dominują? Które formaty wideo zdobywają najwięcej zaangażowania? Zidentyfikuj trendy w treściach kulinarnych.",
        _summaryPromptInitialized: true, filterMethods: ["user_profile", "reel_info"],
      },
      _aiPromptInitialized: false,
    },
  },
},

instagram_reels_food_creators_pl: {
  meta: {
    name: { pl: "Blogerzy kulinarni i twórcy przepisów" },
    desc: { pl: "Znajdź twórców treści kulinarnych, autorów przepisów" },
    badge: "scraping+filtering",
  },
  prefill: {
    taskType: "scraping+filtering",
    taskName: { pl: "Rolki twórców kulinarnych" },
    scraping: {
      selectedSocial: "instagram", selectedPlatform: "instagram_reels",
      whoToFind: "Blogerzy kulinarni i twórcy przepisów",
      keywords: 'przepis\ntutorial gotowania\nblog kulinarny\ndomowe gotowanie\nłatwy przepis\nprzygotowanie posiłków\nrecenzja jedzenia',
      advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 10 },
      scheduleType: "once", parseAuthorPages: false,
    },
    filtering: {
      rules: [], matchType: "all", useAI: true,
      aiGoal: "Filtruj twórców kulinarnych",
      aiPrompt: "", aiMiddlePart: "Sprawdź [[USER_BIO]] i [[USER_SCREENSHOT]]. Czy to twórca treści kulinarnych, autor przepisów lub bloger kulinarny? Tworzy treści o gotowaniu, a nie tylko stronę restauracji.\n\nOdpowiedz 'tak' lub 'nie'.",
      matchWord: "tak", matchScope: "first_line",
      reelsMetrics: {
        enabled: true, minViews: "3000", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
        minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 30,
        sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
        summaryPrompt: "Przeanalizuj te rolki twórców kulinarnych. Jakie typy przepisów są trendy? Które style gotowania zdobywają najwięcej zapisów? Zidentyfikuj wzorce treści.",
        _summaryPromptInitialized: true, filterMethods: ["user_profile"],
      },
      _aiPromptInitialized: false,
    },
  },
},

instagram_reels_fitness_coaches_pl: {
  meta: {
    name: { pl: "Trenerzy fitness i personalni" },
    desc: { pl: "Znajdź trenerów personalnych, instruktorów fitness na Reels" },
    badge: "scraping+filtering",
  },
  prefill: {
    taskType: "scraping+filtering",
    taskName: { pl: "Rolki trenerów fitness" },
    scraping: {
      selectedSocial: "instagram", selectedPlatform: "instagram_reels",
      whoToFind: "Trenerzy fitness i trenerzy personalni",
      keywords: 'plan treningowy\ntrener fitness\ntrener personalny\nporady siłowniane\ntutorial ćwiczeń\nutrata wagi\ntransformacja',
      advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 12 },
      scheduleType: "once", parseAuthorPages: false,
    },
    filtering: {
      rules: [], matchType: "all", useAI: true,
      aiGoal: "Filtruj profesjonalistów fitness",
      aiPrompt: "", aiMiddlePart: "Sprawdź [[USER_BIO]] i [[USER_SCREENSHOT]]. Czy to trener fitness, trener personalny lub instruktor ćwiczeń? Szukaj certyfikatów, programów treningowych, wyników klientów.\n\nOdpowiedz 'tak' lub 'nie'.",
      matchWord: "tak", matchScope: "first_line",
      reelsMetrics: {
        enabled: true, minViews: "2000", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
        minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 30,
        sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
        summaryPrompt: "Przeanalizuj te rolki fitness. Jakie typy treningów dominują? Które formaty zdobywają najwięcej zapisów? Zidentyfikuj wzorce zaangażowania.",
        _summaryPromptInitialized: true, filterMethods: ["user_profile"],
      },
      _aiPromptInitialized: false,
    },
  },
},

instagram_reels_wellness_mindfulness_pl: {
  meta: {
    name: { pl: "Wellness i mindfulness" },
    desc: { pl: "Znajdź jogę, medytację, coachów wellness na Reels" },
    badge: "scraping+filtering",
  },
  prefill: {
    taskType: "scraping+filtering",
    taskName: { pl: "Rolki wellness" },
    scraping: {
      selectedSocial: "instagram", selectedPlatform: "instagram_reels",
      whoToFind: "Coachowie wellness, instruktorzy jogi, twórcy mindfulness",
      keywords: 'praktyka jogi\nporady medytacyjne\ncoach wellness\nuważność\nrutyna samoopieki\nporady zdrowia psychicznego\nzdrowie holistyczne',
      advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 10 },
      scheduleType: "once", parseAuthorPages: false,
    },
    filtering: {
      rules: [], matchType: "all", useAI: true,
      aiGoal: "Filtruj twórców wellness",
      aiPrompt: "", aiMiddlePart: "Sprawdź [[USER_BIO]] i [[REELS_INFO_TEXT]]. Czy to coach wellness, nauczyciel jogi lub praktyk mindfulness? Szukaj certyfikatów, ofert zajęć, informacji o odosobnieniach.\n\nOdpowiedz 'tak' lub 'nie'.",
      matchWord: "tak", matchScope: "first_line",
      reelsMetrics: {
        enabled: true, minViews: "1500", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
        minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 25,
        sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
        summaryPrompt: "Przeanalizuj te rolki wellness. Jakie praktyki są trendy? Które formaty najbardziej rezonują? Zidentyfikuj wzorce treści.",
        _summaryPromptInitialized: true, filterMethods: ["user_profile", "reel_info"],
      },
      _aiPromptInitialized: false,
    },
  },
},

instagram_reels_business_coaches_pl: {
  meta: {
    name: { pl: "Coachowie biznesowi i konsultanci" },
    desc: { pl: "Znajdź coachów biznesowych, konsultantów, mentorów na Reels" },
    badge: "scraping+filtering",
  },
  prefill: {
    taskType: "scraping+filtering",
    taskName: { pl: "Rolki coachów biznesowych" },
    scraping: {
      selectedSocial: "instagram", selectedPlatform: "instagram_reels",
      whoToFind: "Coachowie biznesowi i konsultanci",
      keywords: 'coach biznesowy\nporady dla przedsiębiorców\nstrategia biznesowa\nporady startupowe\nkonsulting\nskalowanie biznesu\nkonsultant marketingowy',
      advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 12 },
      scheduleType: "once", parseAuthorPages: false,
    },
    filtering: {
      rules: [], matchType: "all", useAI: true,
      aiGoal: "Filtruj coachów biznesowych",
      aiPrompt: "", aiMiddlePart: "Sprawdź [[USER_BIO]], [[USER_FULLNAME]] i [[USER_SCREENSHOT]]. Czy to coach biznesowy, konsultant lub mentor, który sprzedaje usługi/programy? Szukaj 'coach', 'konsultant', linków do rezerwacji, wyników klientów.\n\nOdpowiedz 'tak' lub 'nie'.",
      matchWord: "tak", matchScope: "first_line",
      reelsMetrics: {
        enabled: true, minViews: "3000", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
        minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 30,
        sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
        summaryPrompt: "Przeanalizuj te rolki coachingu biznesowego. Jakie tematy są trendy? Które haczyki działają najlepiej? Zidentyfikuj wysokowydajne wzorce treści.",
        _summaryPromptInitialized: true, filterMethods: ["user_profile", "reel_info"],
      },
      _aiPromptInitialized: false,
    },
  },
},

instagram_reels_online_teachers_pl: {
  meta: {
    name: { pl: "Nauczyciele online i twórcy kursów" },
    desc: { pl: "Znajdź edukatorów, korepetytorów, twórców kursów na Reels" },
    badge: "scraping+filtering",
  },
  prefill: {
    taskType: "scraping+filtering",
    taskName: { pl: "Rolki edukatorów" },
    scraping: {
      selectedSocial: "instagram", selectedPlatform: "instagram_reels",
      whoToFind: "Nauczyciele online, korepetytorzy i twórcy kursów",
      keywords: 'kurs online\nucz się online\nkorepetycje\nporady edukacyjne\nsposoby na naukę\nnauczyciel języka\nskillshare',
      advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 10 },
      scheduleType: "once", parseAuthorPages: false,
    },
    filtering: {
      rules: [], matchType: "all", useAI: true,
      aiGoal: "Filtruj edukatorów",
      aiPrompt: "", aiMiddlePart: "Sprawdź [[USER_BIO]] i [[REELS_INFO_TEXT]]. Czy to nauczyciel online, korepetytor lub twórca kursów? Szukaj linków do kursów, kwalifikacji nauczycielskich, treści edukacyjnych.\n\nOdpowiedz 'tak' lub 'nie'.",
      matchWord: "tak", matchScope: "first_line",
      reelsMetrics: {
        enabled: true, minViews: "1500", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
        minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 25,
        sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
        summaryPrompt: "Przeanalizuj te rolki edukacyjne. Jakie przedmioty dominują? Które formaty nauczania działają najlepiej? Zidentyfikuj wzorce zaangażowania.",
        _summaryPromptInitialized: true, filterMethods: ["user_profile", "reel_info"],
      },
      _aiPromptInitialized: false,
    },
  },
},

instagram_reels_real_estate_pl: {
  meta: {
    name: { pl: "Agenci nieruchomości i agencje" },
    desc: { pl: "Znajdź pośredników, agentów nieruchomości na Reels" },
    badge: "scraping+filtering",
  },
  prefill: {
    taskType: "scraping+filtering",
    taskName: { pl: "Rolki nieruchomości" },
    scraping: {
      selectedSocial: "instagram", selectedPlatform: "instagram_reels",
      whoToFind: "Agenci nieruchomości i agencje nieruchomości",
      keywords: 'agent nieruchomości\nprezentacja nieruchomości\ndom na sprzedaż\nżycie pośrednika\nluksusowy dom\nprezentacja mieszkania\nporady nieruchomościowe',
      advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 12 },
      scheduleType: "once", parseAuthorPages: false,
    },
    filtering: {
      rules: [], matchType: "all", useAI: true,
      aiGoal: "Filtruj profesjonalistów nieruchomości",
      aiPrompt: "", aiMiddlePart: "Sprawdź [[USER_BIO]], [[USER_FULLNAME]] i [[REELS_INFO_TEXT]]. Czy to agent nieruchomości, broker lub agencja nieruchomości? Szukaj informacji o licencji, ofert nieruchomości, 'pośrednik', danych kontaktowych.\n\nOdpowiedz 'tak' lub 'nie'.",
      matchWord: "tak", matchScope: "first_line",
      reelsMetrics: {
        enabled: true, minViews: "1500", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
        minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 30,
        sortBy: "views", needFilter: true, needDescription: true, generateSummary: true,
        summaryPrompt: "Przeanalizuj te rolki nieruchomości. Jakie typy nieruchomości dominują? Które formaty wideo zdobywają najwięcej zapytań? Zidentyfikuj trendy.",
        _summaryPromptInitialized: true, filterMethods: ["user_profile", "reel_info"],
      },
      _aiPromptInitialized: false,
    },
  },
},

instagram_reels_travel_creators_pl: {
  meta: {
    name: { pl: "Twórcy podróżniczy i blogerzy" },
    desc: { pl: "Znajdź influencerów podróżniczych, blogerów na Reels" },
    badge: "scraping+filtering",
  },
  prefill: {
    taskType: "scraping+filtering",
    taskName: { pl: "Rolki twórców podróżniczych" },
    scraping: {
      selectedSocial: "instagram", selectedPlatform: "instagram_reels",
      whoToFind: "Twórcy treści podróżniczych i blogerzy",
      keywords: 'vlog podróżniczy\nporady podróżnicze\nprzewodnik po destynacji\nbackpacking\nluksusowe podróże\npodróż solo\nbloger podróżniczy',
      advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["m"], maxPages: 12 },
      scheduleType: "once", parseAuthorPages: false,
    },
    filtering: {
      rules: [], matchType: "all", useAI: true,
      aiGoal: "Filtruj twórców podróżniczych",
      aiPrompt: "", aiMiddlePart: "Sprawdź [[USER_BIO]] i [[USER_SCREENSHOT]]. Czy to twórca treści podróżniczych, bloger lub influencer? Szukaj bio związanego z podróżami, linków do bloga, treści o destynacjach.\n\nOdpowiedz 'tak' lub 'nie'.",
      matchWord: "tak", matchScope: "first_line",
      reelsMetrics: {
        enabled: true, minViews: "5000", maxViews: "", minLikes: "200", maxLikes: "", minComments: "", maxComments: "",
        minEngagementRate: "3", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 30,
        sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
        summaryPrompt: "Przeanalizuj te rolki podróżnicze. Jakie destynacje są trendy? Które formaty zdobywają najwięcej zapisów? Zidentyfikuj wzorce viralowe.",
        _summaryPromptInitialized: true, filterMethods: ["user_profile"],
      },
      _aiPromptInitialized: false,
    },
  },
},

instagram_reels_hotels_resorts_pl: {
  meta: {
    name: { pl: "Hotele i ośrodki wypoczynkowe" },
    desc: { pl: "Znajdź hotele, ośrodki, zakwaterowanie na Reels" },
    badge: "scraping+filtering",
  },
  prefill: {
    taskType: "scraping+filtering",
    taskName: { pl: "Rolki hoteli" },
    scraping: {
      selectedSocial: "instagram", selectedPlatform: "instagram_reels",
      whoToFind: "Hotele, ośrodki wypoczynkowe i zakwaterowanie",
      keywords: 'recenzja hotelu\nżycie w ośrodku\nhotel butikowy\nluksusowy ośrodek\nwynajem wakacyjny\nprezentacja airbnb\nprezentacja pokoju hotelowego',
      advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["m"], maxPages: 10 },
      scheduleType: "once", parseAuthorPages: false,
    },
    filtering: {
      rules: [], matchType: "all", useAI: true,
      aiGoal: "Filtruj hotele/ośrodki",
      aiPrompt: "", aiMiddlePart: "Sprawdź [[USER_BIO]], [[REELS_INFO_TEXT]] i [[USER_SCREENSHOT]]. Czy to hotel, ośrodek wypoczynkowy lub firma zakwaterowania? Szukaj linków do rezerwacji, lokalizacji, cech obiektu.\n\nOdpowiedz 'tak' lub 'nie'.",
      matchWord: "tak", matchScope: "first_line",
      reelsMetrics: {
        enabled: true, minViews: "3000", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
        minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 25,
        sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
        summaryPrompt: "Przeanalizuj te rolki hotelowe. Jakie typy obiektów są trendy? Które cechy są najczęściej podkreślane? Zidentyfikuj wzorce treści.",
        _summaryPromptInitialized: true, filterMethods: ["user_profile", "reel_info"],
      },
      _aiPromptInitialized: false,
    },
  },
},

instagram_reels_saas_founders_pl: {
  meta: {
    name: { pl: "Founderzy SaaS i startupy" },
    desc: { pl: "Znajdź firmy SaaS, founderów startupów na Reels" },
    badge: "scraping+filtering",
  },
  prefill: {
    taskType: "scraping+filtering",
    taskName: { pl: "Rolki founderów SaaS" },
    scraping: {
      selectedSocial: "instagram", selectedPlatform: "instagram_reels",
      whoToFind: "Founderzy SaaS i startupy technologiczne",
      keywords: 'founder saas\nżycie startupu\nprzedsiębiorca technologiczny\nfirma programistyczna\npremiera produktu\nbootstrapping\nindie hacker',
      advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["m"], maxPages: 10 },
      scheduleType: "once", parseAuthorPages: false,
    },
    filtering: {
      rules: [], matchType: "all", useAI: true,
      aiGoal: "Filtruj firmy SaaS/tech",
      aiPrompt: "", aiMiddlePart: "Sprawdź [[USER_BIO]], [[USER_FULLNAME]] i [[REELS_INFO_TEXT]]. Czy to founder SaaS, startup technologiczny lub firma programistyczna? Szukaj linków do produktów, 'SaaS', 'startup', wzmianek o stacku technologicznym.\n\nOdpowiedz 'tak' lub 'nie'.",
      matchWord: "tak", matchScope: "first_line",
      reelsMetrics: {
        enabled: true, minViews: "2000", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
        minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 25,
        sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
        summaryPrompt: "Przeanalizuj te rolki SaaS. Jakie produkty są prezentowane? Które typy treści napędzają zaangażowanie? Zidentyfikuj trendy.",
        _summaryPromptInitialized: true, filterMethods: ["user_profile", "reel_info"],
      },
      _aiPromptInitialized: false,
    },
  },
},

instagram_reels_local_business_pl: {
  meta: {
    name: { pl: "Lokalne małe firmy" },
    desc: { pl: "Znajdź lokalne sklepy, salony, usługi na Reels" },
    badge: "scraping+filtering",
  },
  prefill: {
    taskType: "scraping+filtering",
    taskName: { pl: "Rolki lokalnych firm" },
    scraping: {
      selectedSocial: "instagram", selectedPlatform: "instagram_reels",
      whoToFind: "Lokalne małe firmy promujące się na Instagramie",
      keywords: 'mała firma\ncentrum miasta\nlokalny sklep\nmały biznes\nmiasto\nulica handlowa\nlokalna firma',
      advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["m"], maxPages: 10 },
      scheduleType: "once", parseAuthorPages: false,
    },
    filtering: {
      rules: [], matchType: "all", useAI: true,
      aiGoal: "Filtruj lokalne firmy",
      aiPrompt: "", aiMiddlePart: "Sprawdź [[USER_BIO]], [[REELS_INFO_TEXT]] i [[USER_SCREENSHOT]]. Czy to lokalna mała firma (sklep, salon, usługa, kawiarnia)? Szukaj adresu, godzin otwarcia, usług, lokalnych hashtagów.\n\nOdpowiedz 'tak' lub 'nie'.",
      matchWord: "tak", matchScope: "first_line",
      reelsMetrics: {
        enabled: true, minViews: "500", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
        minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 30,
        sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
        summaryPrompt: "Przeanalizuj te rolki lokalnych firm. Jakie typy firm dominują? Które formaty przyciągają klientów? Zidentyfikuj trendy marketingu lokalnego.",
        _summaryPromptInitialized: true, filterMethods: ["user_profile", "reel_info"],
      },
      _aiPromptInitialized: false,
    },
  },
},

instagram_reels_artists_designers_pl: {
  meta: {
    name: { pl: "Artyści i projektanci" },
    desc: { pl: "Znajdź artystów wizualnych, grafików na Reels" },
    badge: "scraping+filtering",
  },
  prefill: {
    taskType: "scraping+filtering",
    taskName: { pl: "Rolki artystów" },
    scraping: {
      selectedSocial: "instagram", selectedPlatform: "instagram_reels",
      whoToFind: "Artyści wizualni, ilustratorzy, graficy",
      keywords: 'sztuka cyfrowa\nilustracja\npracownia artysty\nprojektowanie graficzne\nproces twórczy\nzlecenia otwarte\nportfolio artystyczne',
      advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["m"], maxPages: 10 },
      scheduleType: "once", parseAuthorPages: false,
    },
    filtering: {
      rules: [], matchType: "all", useAI: true,
      aiGoal: "Filtruj artystów/projektantów",
      aiPrompt: "", aiMiddlePart: "Sprawdź [[USER_BIO]] i [[USER_SCREENSHOT]]. Czy to artysta wizualny, ilustrator lub grafik? Szukaj linków do portfolio, informacji o zleceniach, opisów stylu artystycznego.\n\nOdpowiedz 'tak' lub 'nie'.",
      matchWord: "tak", matchScope: "first_line",
      reelsMetrics: {
        enabled: true, minViews: "1500", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
        minEngagementRate: "", maxEngagementRate: "", engagementFormula: "simple", topReelsCount: 25,
        sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
        summaryPrompt: "Przeanalizuj te rolki artystów. Jakie style sztuki są trendy? Które filmy procesowe działają najlepiej? Zidentyfikuj wzorce zaangażowania.",
        _summaryPromptInitialized: true, filterMethods: ["user_profile"],
      },
      _aiPromptInitialized: false,
    },
  },
},

instagram_reels_photographers_pl: {
  meta: {
    name: { pl: "Fotografowie i kamerzyści" },
    desc: { pl: "Znajdź profesjonalnych fotografów na Reels" },
    badge: "scraping+filtering",
  },
  prefill: {
    taskType: "scraping+filtering",
    taskName: { pl: "Rolki fotografów" },
    scraping: {
      selectedSocial: "instagram", selectedPlatform: "instagram_reels",
      whoToFind: "Profesjonalni fotografowie i kamerzyści",
      keywords: 'porady fotograficzne\nza kulisami sesji\nkonfiguracja aparatu\nfotograf ślubny\nfilmowiec\nedycja zdjęć\nbiznes fotograficzny',
      advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["m"], maxPages: 10 },
      scheduleType: "once", parseAuthorPages: false,
    },
    filtering: {
      rules: [], matchType: "all", useAI: true,
      aiGoal: "Filtruj fotografów",
      aiPrompt: "", aiMiddlePart: "Sprawdź [[USER_BIO]] i [[USER_SCREENSHOT]]. Czy to profesjonalny fotograf lub kamerzysta oferujący usługi? Szukaj portfolio, informacji o rezerwacji, wzmianek o sprzęcie.\n\nOdpowiedz 'tak' lub 'nie'.",
      matchWord: "tak", matchScope: "first_line",
      reelsMetrics: {
        enabled: true, minViews: "2000", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
        minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 25,
        sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
        summaryPrompt: "Przeanalizuj te rolki fotografów. Jakie nisze dominują? Które formaty najlepiej pokazują pracę? Zidentyfikuj trendy portfolio.",
        _summaryPromptInitialized: true, filterMethods: ["user_profile"],
      },
      _aiPromptInitialized: false,
    },
  },
},

instagram_reels_smm_creators_pl: {
  meta: {
    name: { pl: "Twórcy i agencje SMM" },
    desc: { pl: "Znajdź twórców SMM publikujących porady, strategie, case studies" },
    badge: "scraping+filtering",
  },
  prefill: {
    taskType: "scraping+filtering",
    taskName: { pl: "Rolki twórców SMM" },
    scraping: {
      selectedSocial: "instagram", selectedPlatform: "instagram_reels",
      whoToFind: "Twórcy SMM publikujący porady i strategie",
      keywords: 'porady smm\nstrategia social media\nporady twórców treści\nsocial media manager\nwzrost instagrama\nagencja smm\nsocial media marketing',
      advancedSettings: { searchLanguage: "pl", scrapingPeriods: ["d"], maxPages: 10 },
      scheduleType: "once", parseAuthorPages: false,
    },
    filtering: {
      rules: [], matchType: "all", useAI: true,
      aiGoal: "Filtruj twórców SMM",
      aiPrompt: "", aiMiddlePart: "Sprawdź [[USER_SCREENSHOT]] i [[USER_BIO]]. Czy to twórca SMM, agencja lub ekspert social media? Powinni publikować o marketingu social media, strategii treści, growth hackach lub wynikach klientów.\n\nOdpowiedz 'tak' lub 'nie'.",
      matchWord: "tak", matchScope: "first_line",
      reelsMetrics: {
        enabled: true, minViews: "5000", maxViews: "", minLikes: "", maxLikes: "", minComments: "", maxComments: "",
        minEngagementRate: "", maxEngagementRate: "", engagementFormula: "standard", topReelsCount: 30,
        sortBy: "engagement", needFilter: true, needDescription: true, generateSummary: true,
        summaryPrompt: "Przeanalizuj te najlepsze rolki SMM. Zidentyfikuj trendy tematów, popularne haczyki, wzorce zaangażowania i formaty treści, które działają najlepiej.",
        _summaryPromptInitialized: true, filterMethods: ["user_profile"],
      },
      _aiPromptInitialized: false,
    },
  },
},

};

export default templateData;